// src/pages/DriverHome.js  v3.5
// Correções v3.5:
//  - online sempre começa false + reseta no Firestore ao abrir app
//  - painelAberto começa false — botão ONLINE sempre visível na barra inferior
//  - Painel expandido mostra stats + plano + botão ONLINE grande centralizado
//  - Painel fechado mostra: saudação + botão ONLINE pequeno + avatar

import React, { useEffect, useState, useRef, useCallback } from "react";
import CobrancaFlexBanner from "../components/CobrancaFlexBanner";
import useDriverLocation from "../hooks/useDriverLocation";
import { watchLocation } from "../services/locationService";
import { signOut, onAuthStateChanged, updateProfile } from "firebase/auth";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc, collection, query, where, orderBy, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { aceitarCorrida, iniciarCorrida, concluirCorrida, cancelarCorrida, avaliarPassageiro, atualizarMetodoPagamento, chegouNoPassageiro, getHistoricoCorridas, escutarCorridasPendentes, escutarAgendadasParaMotorista } from "../services/rideService";
import RatingModal from "../components/RatingModal";
import SOSButton from "../components/SOSButton";
import ModalGanhos from "../components/ModalGanhos";
import { getPlanoMotorista, verificarAvisoVencimento } from "../services/planoService";
import { inicializarNotificacoes, limparTokenNotificacoes } from "../services/notificationService";
import { requestAccountDeletion } from "../services/accountService";
import ChatCorrida from "../components/ChatCorrida";
import PaymentSelector from "../components/PaymentSelector";
import { getDriverEligibility, setDriverOnlineSecure, updateDriverPlanChoice } from "../services/driverOnboardingService";
import { clearAuthScopedClientState } from "../services/clientStorageSecurity";

// ─── SOM DE ALERTA ────────────────────────────────────────────
function tocarSomAlerta() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const beep = (freq, start, dur) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.frequency.value = freq;
      o.type = "sine";
      g.gain.setValueAtTime(0, ctx.currentTime + start);
      g.gain.linearRampToValueAtTime(0.4, ctx.currentTime + start + 0.02);
      g.gain.linearRampToValueAtTime(0, ctx.currentTime + start + dur);
      o.start(ctx.currentTime + start);
      o.stop(ctx.currentTime + start + dur + 0.05);
    };
    beep(880, 0,    0.15);
    beep(1100, 0.2, 0.15);
    beep(880, 0.4,  0.15);
    beep(1100, 0.6, 0.25);
  } catch (e) { /* navegador pode bloquear sem interação */ }
}

// ─── COMPRESSÃO DE IMAGEM (evita falha no upload por arquivo grande) ───
function comprimirImagemDriver(file, maxPx = 480) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = (ev) => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        let w = img.width, h = img.height;
        if (w > h) { if (w > maxPx) { h = Math.round(h * maxPx / w); w = maxPx; } }
        else        { if (h > maxPx) { w = Math.round(w * maxPx / h); h = maxPx; } }
        const canvas = document.createElement("canvas");
        canvas.width = w; canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error("canvas vazio")), "image/jpeg", 0.82);
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  });
}

// ─── ÍCONES PREMIUM ───────────────────────────────────────────
const IconHome = ({ active }) => {
  const c = active ? "#a855f7" : "rgba(255,255,255,0.38)";
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {active && <path d="M3 11.5L12 4l9 7.5V20a1 1 0 01-1 1h-5v-5H9v5H4a1 1 0 01-1-1V11.5z" fill="#a855f7" opacity="0.18"/>}
      <path d="M3 11.5L12 4l9 7.5V20a1 1 0 01-1 1h-5v-5H9v5H4a1 1 0 01-1-1V11.5z" stroke={c} strokeWidth="1.8" strokeLinejoin="round" fill="none"/>
    </svg>
  );
};
const IconRides = ({ active }) => {
  const c = active ? "#a855f7" : "rgba(255,255,255,0.38)";
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Ponto origem */}
      <circle cx="5" cy="6" r="2.5" stroke={c} strokeWidth="1.8" fill={active ? "#a855f7" : "none"}/>
      {/* Ponto destino */}
      <path d="M19 15.5c0 2-2 4-2 4s-2-2-2-4a2 2 0 014 0z" stroke={c} strokeWidth="1.8" strokeLinejoin="round" fill={active ? "rgba(168,85,247,0.2)" : "none"}/>
      {/* Caminho curvo conectando */}
      <path d="M5 8.5C5 12 10 12 12 15.5" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeDasharray={active ? "none" : "none"}/>
      <path d="M12 15.5C14 19 19 15.5 19 15.5" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
};
const IconProfile = ({ active }) => {
  const c = active ? "#a855f7" : "rgba(255,255,255,0.38)";
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {active && <circle cx="12" cy="8" r="3.5" fill="#a855f7" opacity="0.22"/>}
      <circle cx="12" cy="8" r="3.5" stroke={c} strokeWidth="1.8"/>
      <path d="M4.5 20c0-3.038 3.358-5.5 7.5-5.5s7.5 2.462 7.5 5.5" stroke={c} strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      {active && <>
        <circle cx="17.5" cy="6.5" r="3" fill="#22c55e" stroke="#0a0e1a" strokeWidth="1.2"/>
        <polyline points="16.2,6.5 17.2,7.6 19.1,5.4" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
      </>}
    </svg>
  );
};
const IconSettings = ({ active }) => {
  const c = active ? "#a855f7" : "rgba(255,255,255,0.38)";
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {active && <circle cx="12" cy="12" r="3" fill="#a855f7" opacity="0.25"/>}
      <circle cx="12" cy="12" r="3" stroke={c} strokeWidth="1.8"/>
      <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
};
const IconCamera = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);
const IconChevron = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18l6-6-6-6"/>
  </svg>
);
const IconStar = ({ filled }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill={filled ? "#f59e0b" : "none"} stroke="#f59e0b" strokeWidth="2">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);
const IconChat = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);
const IconMoney = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
  </svg>
);
const IconMap = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 11 22 2 13 21 11 13 3 11"/>
  </svg>
);

// ─── HAVERSINE ────────────────────────────────────────────────
function haversineKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLng/2)**2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

function iconePagamento(metodo) {
  if (metodo === "pix") return { icon: "📱", label: "Pix", cor: "#06b6d4" };
  if (metodo === "maquininha") return { icon: "💳", label: "Cartão", cor: "#3b82f6" };
  return { icon: "💵", label: "Dinheiro", cor: "#22c55e" };
}

// ─── PROGRESSO DA CORRIDA ────────────────────────────────────
function ProgressoCorrida({ corridaAtiva, driverLat, driverLng, onProgressoUpdate }) {
  const [progresso, setProgresso] = useState(0);
  const [kmRestante, setKmRestante] = useState(null);
  const [minRestante, setMinRestante] = useState(null);
  const [fase, setFase] = useState("indo_buscar");
  const distTotalRef = useRef(null);
  const corridaIdRef = useRef(null);
  const emAndamentoRef = useRef(false);
  const iniciadoEmRef = useRef(null);
  const emAndamento = corridaAtiva?.status === "in_progress";

  useEffect(() => {
    if (!corridaAtiva) { distTotalRef.current = null; return; }
    const novaCorridaOuFase = corridaIdRef.current !== corridaAtiva.id || emAndamentoRef.current !== emAndamento;
    if (novaCorridaOuFase) {
      distTotalRef.current = null; corridaIdRef.current = corridaAtiva.id;
      emAndamentoRef.current = emAndamento;
      iniciadoEmRef.current = emAndamento && corridaAtiva.iniciadoEm
        ? (corridaAtiva.iniciadoEm.toDate ? corridaAtiva.iniciadoEm.toDate() : new Date(corridaAtiva.iniciadoEm)) : null;
      setProgresso(0);
    }
  }, [corridaAtiva?.id, emAndamento]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!driverLat || !driverLng || !corridaAtiva) return;
    const targetLat = emAndamento ? corridaAtiva.destino?.lat : corridaAtiva.origem?.lat;
    const targetLng = emAndamento ? corridaAtiva.destino?.lng : corridaAtiva.origem?.lng;
    if (!targetLat || !targetLng) return;
    const kmRest = haversineKm(driverLat, driverLng, targetLat, targetLng);
    if (distTotalRef.current === null) {
      distTotalRef.current = (emAndamento ? (corridaAtiva.distanciaKm || corridaAtiva.dadosCorrida?.distanciaKm || null) : null) || kmRest;
    }
    const kmTotal = distTotalRef.current;
    let pct = kmTotal > 0 ? (Math.max(0, kmTotal - kmRest) / kmTotal) * 100 : 0;
    if (pct < 2 && emAndamento && iniciadoEmRef.current) {
      pct = Math.min(98, ((Date.now() - iniciadoEmRef.current.getTime()) / 60000) / (corridaAtiva.tempoMin || corridaAtiva.dadosCorrida?.tempoMin || 20) * 100);
    }
    pct = Math.min(98, Math.max(0, pct));
    const novaFase = emAndamento ? (pct >= 85 ? "chegando" : "passageiro_bordo") : (pct >= 88 ? "chegando" : "indo_buscar");
    setProgresso(Math.round(pct)); setKmRestante(+kmRest.toFixed(1)); setMinRestante(Math.max(1, Math.round((kmRest/30)*60))); setFase(novaFase);
    onProgressoUpdate?.({ kmRestante: +kmRest.toFixed(1), minRestante: Math.max(1, Math.round((kmRest/30)*60)), progresso: Math.round(pct) });
  }, [driverLat, driverLng, corridaAtiva, emAndamento]); // eslint-disable-line react-hooks/exhaustive-deps

  const faseConfig = {
    indo_buscar:      { cor: "#22c55e", label: "🚗 Indo buscar passageiro", sub: "A caminho do ponto de embarque" },
    passageiro_bordo: { cor: "#a855f7", label: "👤 Passageiro a bordo",     sub: "Em rota ao destino"            },
    chegando:         { cor: "#f59e0b", label: "📍 Chegando ao destino",    sub: "Quase lá!"                     },
  };
  const cfg = faseConfig[fase] || faseConfig.indo_buscar;
  if (!corridaAtiva) return null;
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8 }}>
        <div>
          <p style={{ color:cfg.cor, fontWeight:700, fontSize:13, margin:0 }}>{cfg.label}</p>
          <p style={{ color:"rgba(255,255,255,0.35)", fontSize:11, margin:"2px 0 0" }}>{cfg.sub}</p>
        </div>
        <div style={{ textAlign:"right" }}>
          {minRestante !== null && <p style={{ color:"#fff", fontWeight:800, fontSize:18, margin:0 }}>{minRestante < 1 ? "<1" : minRestante} <span style={{ fontSize:12, fontWeight:400, color:"rgba(255,255,255,0.4)" }}>min</span></p>}
          {kmRestante !== null && <p style={{ color:"rgba(255,255,255,0.4)", fontSize:11, margin:"1px 0 0" }}>{kmRestante} km restantes</p>}
        </div>
      </div>
      <div style={{ height:8, background:"rgba(255,255,255,0.07)", borderRadius:6, overflow:"hidden", marginBottom:6 }}>
        <div style={{ height:"100%", borderRadius:6, background:`linear-gradient(90deg,${cfg.cor}88,${cfg.cor})`, width:`${progresso}%`, transition:"width 1.4s ease", position:"relative" }}>
          {progresso > 3 && progresso < 99 && <div style={{ position:"absolute", right:0, top:"50%", transform:"translateY(-50%)", width:12, height:12, borderRadius:"50%", background:cfg.cor, animation:"pulse 1.5s ease-in-out infinite" }} />}
        </div>
      </div>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>Início</span>
        <span style={{ fontSize:11, color:cfg.cor, fontWeight:700 }}>{progresso}%</span>
        <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{emAndamento ? (corridaAtiva.destino?.nome||"Destino") : "Passageiro"}</span>
      </div>
    </div>
  );
}

// ─── MAPA PRINCIPAL ───────────────────────────────────────────
// Zonas quentes fixas por cidade (podem ser expandidas via Firestore futuramente)
const ZONAS_QUENTES = [
  { lat:-23.5505, lng:-46.6333, label:"Centro SP",   raio:800,  cor:"#ef4444" },
  { lat:-23.5613, lng:-46.6560, label:"Pinheiros",   raio:600,  cor:"#f59e0b" },
  { lat:-23.5987, lng:-46.6596, label:"Brooklin",    raio:500,  cor:"#f59e0b" },
  { lat:-23.5330, lng:-46.6536, label:"Higienópolis",raio:500,  cor:"#f59e0b" },
  { lat:-23.5489, lng:-46.6388, label:"República",   raio:700,  cor:"#ef4444" },
];

function MapaPrincipal({ driverLat, driverLng, online, mostrarZonas, navAlvo }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);
  const zonasRef = useRef([]);
  const directionsRendererRef = useRef(null);
  const directionsRendererBordaRef = useRef(null); // linha de borda branca (efeito Uber)
  const directionsServiceRef = useRef(null);
  const rotaAlvoRef = useRef(null); // evita recalcular a mesma rota
  const prevLatLngRef = useRef(null); // para calcular heading
  const headingRef = useRef(0);
  const [googlePronto, setGooglePronto] = useState(!!window.google?.maps);

  useEffect(() => {
    if (window.google?.maps) { setGooglePronto(true); return; }
    const iv = setInterval(() => { if (window.google?.maps) { clearInterval(iv); setGooglePronto(true); } }, 300);
    return () => clearInterval(iv);
  }, []);

  // Desenha/remove zonas quentes no mapa
  useEffect(() => {
    if (!googlePronto || !mapInstanceRef.current) return;
    // Remove zonas anteriores
    zonasRef.current.forEach(({ circle, label }) => { circle.setMap(null); label.close(); });
    zonasRef.current = [];
    if (!mostrarZonas) return;
    ZONAS_QUENTES.forEach(z => {
      const circle = new window.google.maps.Circle({
        map: mapInstanceRef.current,
        center: { lat: z.lat, lng: z.lng },
        radius: z.raio,
        fillColor: z.cor,
        fillOpacity: 0.15,
        strokeColor: z.cor,
        strokeOpacity: 0.5,
        strokeWeight: 1.5,
        clickable: false,
      });
      // Label via InfoWindow leve (sem Marker deprecado)
      const label = new window.google.maps.InfoWindow({
        content: `<div style="background:${z.cor};color:#fff;font-size:10px;font-weight:700;padding:3px 8px;border-radius:10px;white-space:nowrap">🔥 ${z.label}</div>`,
        position: { lat: z.lat, lng: z.lng },
        disableAutoPan: true,
      });
      label.open(mapInstanceRef.current);
      zonasRef.current.push({ circle, label });
    });
  }, [googlePronto, mostrarZonas]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!googlePronto || !mapRef.current || mapInstanceRef.current) return;
    const lat = driverLat || -26.4833, lng = driverLng || -49.0667; // Jaraguá do Sul, SC
    mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
      center: { lat, lng }, zoom: 17, gestureHandling: "greedy",
      mapTypeControl: false, streetViewControl: false, fullscreenControl: false,
      rotateControl: false, scaleControl: false, zoomControl: false,
      tilt: 45,
      styles: [
        { featureType:"poi", stylers:[{ visibility:"off" }] },
        { featureType:"transit", stylers:[{ visibility:"off" }] },
        { featureType:"road", elementType:"geometry", stylers:[{ color:"#f5f5f5" }] },
        { featureType:"road.highway", elementType:"geometry", stylers:[{ color:"#e8e8e8" }] },
        { featureType:"road", elementType:"labels.text.fill", stylers:[{ color:"#616161" }] },
        { featureType:"water", elementType:"geometry", stylers:[{ color:"#c9d9e8" }] },
        { featureType:"landscape", elementType:"geometry", stylers:[{ color:"#eeeeee" }] },
      ],
    });
    criarOuAtualizarMarcador(lat, lng, online, true);
  }, [googlePronto]); // eslint-disable-line react-hooks/exhaustive-deps

  const gerarSvg = (isOnline) => {
    const c1 = isOnline ? "#06b6d4" : "#4b5563", c2 = isOnline ? "#7c3aed" : "#374151", cb = isOnline ? "#22d3ee" : "#6b7280";
    return encodeURIComponent(`<svg width="56" height="66" viewBox="0 0 56 66" xmlns="http://www.w3.org/2000/svg"><defs><radialGradient id="bg" cx="40%" cy="35%" r="65%"><stop offset="0%" stop-color="${c1}"/><stop offset="100%" stop-color="${c2}"/></radialGradient></defs><ellipse cx="28" cy="64" rx="10" ry="3" fill="rgba(0,0,0,0.3)"/><circle cx="28" cy="27" r="25" fill="url(#bg)"/><circle cx="28" cy="27" r="25" fill="none" stroke="${cb}" stroke-width="2" opacity="0.8"/><text x="28" y="36" text-anchor="middle" font-family="Arial Black" font-weight="900" font-size="26" fill="white">Z</text><polygon points="28,56 19,44 37,44" fill="${c2}"/><polygon points="28,54 20,44 36,44" fill="${c1}" opacity="0.6"/></svg>`);
  };

  const criarOuAtualizarMarcador = (lat, lng, isOnline, criar = false) => {
    if (!mapInstanceRef.current || !window.google) return;
    const icon = { url: `data:image/svg+xml;charset=UTF-8,${gerarSvg(isOnline)}`, scaledSize: new window.google.maps.Size(56,66), anchor: new window.google.maps.Point(28,58) };
    if (criar || !markerRef.current) markerRef.current = new window.google.maps.Marker({ position:{lat,lng}, map:mapInstanceRef.current, icon, zIndex:10 });
    else { markerRef.current.setPosition({lat,lng}); markerRef.current.setIcon(icon); }
  };

  useEffect(() => {
    if (!googlePronto || !mapInstanceRef.current) return;
    const lat = driverLat || -26.4833, lng = driverLng || -49.0667; // Jaraguá do Sul, SC
    criarOuAtualizarMarcador(lat, lng, online);
    // Calcula heading entre última posição e atual
    if (driverLat && driverLng && prevLatLngRef.current) {
      const prev = prevLatLngRef.current;
      const dLat = lat - prev.lat;
      const dLng = lng - prev.lng;
      if (Math.abs(dLat) > 0.00005 || Math.abs(dLng) > 0.00005) {
        headingRef.current = Math.atan2(dLng, dLat) * (180 / Math.PI);
      }
    }
    if (driverLat && driverLng) prevLatLngRef.current = { lat, lng };
    // Quando tem corrida ativa: 3D follow cam; senão: mapa normal
    if (driverLat && driverLng && navAlvo) {
      mapInstanceRef.current.panTo({ lat, lng });
      mapInstanceRef.current.setZoom(17);
      mapInstanceRef.current.setTilt(50);
      mapInstanceRef.current.setHeading(headingRef.current);
    } else if (driverLat && driverLng) {
      mapInstanceRef.current.panTo({ lat, lng });
      mapInstanceRef.current.setTilt(0);
    }
  }, [driverLat, driverLng, online, googlePronto, navAlvo]); // eslint-disable-line react-hooks/exhaustive-deps

  // Desenha/atualiza rota estilo Uber: borda branca + linha azul viva
  useEffect(() => {
    if (!googlePronto || !mapInstanceRef.current || !window.google) return;

    // Inicializa serviços na primeira vez
    if (!directionsServiceRef.current) {
      directionsServiceRef.current = new window.google.maps.DirectionsService();
    }
    // Renderer borda (branca, mais grossa) — fica embaixo
    if (!directionsRendererBordaRef.current) {
      directionsRendererBordaRef.current = new window.google.maps.DirectionsRenderer({
        suppressMarkers: true,
        polylineOptions: { strokeColor: "#ffffff", strokeWeight: 12, strokeOpacity: 0.95, zIndex: 1 },
      });
      directionsRendererBordaRef.current.setMap(mapInstanceRef.current);
    }
    // Renderer principal (azul) — fica em cima
    if (!directionsRendererRef.current) {
      directionsRendererRef.current = new window.google.maps.DirectionsRenderer({
        suppressMarkers: true,
        polylineOptions: { strokeColor: "#2563eb", strokeWeight: 8, strokeOpacity: 1, zIndex: 2 },
      });
      directionsRendererRef.current.setMap(mapInstanceRef.current);
    }

    // Remove rota se não há destino
    if (!navAlvo?.lat || !navAlvo?.lng || !driverLat || !driverLng) {
      directionsRendererRef.current.setDirections({ routes: [] });
      directionsRendererBordaRef.current.setDirections({ routes: [] });
      rotaAlvoRef.current = null;
      return;
    }

    // Re-roteia quando destino ou posição do motorista mudam (~150m de precisão)
    const chaveAlvo = `${navAlvo.lat.toFixed(4)},${navAlvo.lng.toFixed(4)}_${driverLat.toFixed(3)},${driverLng.toFixed(3)}`;
    if (rotaAlvoRef.current === chaveAlvo) return;
    rotaAlvoRef.current = chaveAlvo;

    directionsServiceRef.current.route(
      {
        origin: { lat: driverLat, lng: driverLng },
        destination: { lat: navAlvo.lat, lng: navAlvo.lng },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          directionsRendererRef.current.setDirections(result);
          directionsRendererBordaRef.current.setDirections(result);
          // Não ajusta bounds — mantém o follow cam no motorista
        }
      }
    );
  }, [googlePronto, navAlvo, driverLat, driverLng]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ position:"relative", width:"100%", height:"100%" }}>
      <div ref={mapRef} style={{ width:"100%", height:"100%" }} />
      {!googlePronto && (
        <div style={{ position:"absolute", inset:0, background:"#e8eff5", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:12 }}>
          <div style={{ width:56, height:56, borderRadius:"50%", background: online?"linear-gradient(135deg,#06b6d4,#7c3aed)":"linear-gradient(135deg,#4b5563,#374151)", border:`3px solid ${online?"#22d3ee":"#6b7280"}`, display:"flex", alignItems:"center", justifyContent:"center", animation:"pulse 1.5s ease-in-out infinite" }}>
            <span style={{ color:"white", fontSize:26, fontWeight:900, fontFamily:"Arial Black, sans-serif" }}>Z</span>
          </div>
          <p style={{ color:"#666", fontSize:12 }}>Carregando mapa...</p>
        </div>
      )}
    </div>
  );
}

// ─── BOTÕES NAVEGAÇÃO ─────────────────────────────────────────
function BotoesNavegacao({ lat, lng }) {
  if (!lat || !lng) return null;
  return (
    <div style={{ display:"flex", gap:8, marginBottom:12 }}>
      <button onClick={() => window.open(`https://waze.com/ul?ll=${lat},${lng}&navigate=yes`,"_blank")} style={{ flex:1, padding:"10px", borderRadius:10, background:"rgba(0,210,145,0.12)", border:"1px solid rgba(0,210,145,0.3)", color:"#00d291", fontSize:12, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
        <span style={{ fontSize:16 }}>🗺️</span> Waze
      </button>
      <button onClick={() => window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`,"_blank")} style={{ flex:1, padding:"10px", borderRadius:10, background:"rgba(66,133,244,0.12)", border:"1px solid rgba(66,133,244,0.3)", color:"#4285F4", fontSize:12, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
        <IconMap /> Google Maps
      </button>
    </div>
  );
}

// ─── BANNER TRIAL ─────────────────────────────────────────────
function BannerTrialDiario({ planoInfo }) {
  const [visivel, setVisivel] = useState(false);
  useEffect(() => {
    if (!planoInfo?.trialAtivo) return;
    const hoje = new Date().toISOString().slice(0,10);
    if (localStorage.getItem("bannerTrialFechado") !== hoje) {
      setVisivel(true);
      const t = setTimeout(() => {
        localStorage.setItem("bannerTrialFechado", hoje);
        setVisivel(false);
      }, 5000);
      return () => clearTimeout(t);
    }
  }, [planoInfo]);
  if (!visivel || !planoInfo?.trialAtivo) return null;
  const diasRestantes = planoInfo.diasRestantes || 0;
  const diasUsados = 30 - diasRestantes;
  return (
    <div style={{ margin:"8px 16px", background:"rgba(34,197,94,0.08)", border:"1px solid rgba(34,197,94,0.2)", borderRadius:14, padding:"12px 16px" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
        <span style={{ fontSize:20, flexShrink:0 }}>🎉</span>
        <div style={{ flex:1 }}>
          <p style={{ fontSize:13, fontWeight:700, color:"#22c55e", margin:0 }}>{diasRestantes > 0 ? `${diasRestantes} dias grátis restantes!` : "Último dia do período grátis!"}</p>
          <p style={{ fontSize:11, color:"rgba(255,255,255,0.4)", margin:0 }}>Nenhuma taxa cobrada durante o trial.</p>
        </div>
      </div>
      <div style={{ height:5, background:"rgba(255,255,255,0.08)", borderRadius:10, overflow:"hidden" }}>
        <div style={{ height:"100%", width:`${Math.min(100,(diasUsados/30)*100)}%`, background:"linear-gradient(90deg,#22c55e,#16a34a)", borderRadius:10 }} />
      </div>
    </div>
  );
}

// ─── COMPONENTE PRINCIPAL ─────────────────────────────────────
function DriverHome() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("home");
  const [online, setOnline] = useState(false); // sempre começa offline
  const [loading, setLoading] = useState(true);
  const [loadingDemorou, setLoadingDemorou] = useState(false);
  const [motorista, setMotorista] = useState(null);
  const [user, setUser] = useState(null);
  const [tempoInicioOnline, setTempoInicioOnline] = useState(null);
  const [tempoDisplay, setTempoDisplay] = useState("00:00:00");
  const [fotoURL, setFotoURL] = useState(null);
  const [uploadingFoto, setUploadingFoto] = useState(false);
  const [notificacoes, setNotificacoes] = useState(true);
  const [sons, setSons] = useState(true);
  const [savedMsg, setSavedMsg] = useState("");
  const fileInputRef = useRef(null);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [uploadingQr, setUploadingQr] = useState(false);
  const qrInputRef = useRef(null);
  const [pixRecebido, setPixRecebido] = useState(false);
  const [driverLat, setDriverLat] = useState(null);
  const [driverLng, setDriverLng] = useState(null);
  const driverLatRef = useRef(null);
  const driverLngRef = useRef(null);
  const gpsWatchRef = useRef(null);
  const primeiroAuthRef = useRef(true); // evita resetar online em refreshes de token
  const [bonusInfo, setBonusInfo] = useState(null);
  const [bonusToast, setBonusToast] = useState(null);
  const [planoInfo, setPlanoInfo] = useState(null);
  const [avisoPlano, setAvisoPlano] = useState(null);
  const [corridaRecebida, setCorridaRecebida] = useState(null);
  const corridaRecebidaRef = useRef(null);
  const [corridaAtiva, setCorridaAtiva] = useState(null);
  const [aceitando, setAceitando] = useState(false);
  const [cancelando, setCancelando] = useState(false);
  const [tempoRestante, setTempoRestante] = useState(30);
  const timerRef = useRef(null);
  const unsubPendentesRef = useRef(null);
  const corridaAtivaRef = useRef(null); // ref para evitar recriar listener de pendentes
  const [proximaCorridaAceita, setProximaCorridaAceita] = useState(null);
  const proximaCorridaAceitaRef = useRef(null);
  const unsubAtivaRef = useRef(null);
  const [showRating, setShowRating] = useState(false);
  const [corridaCompletada, setCorridaCompletada] = useState(null);
  const [showGanhos, setShowGanhos] = useState(false);
  const [dadosGanhos, setDadosGanhos] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [showPaymentSelector, setShowPaymentSelector] = useState(false);
  const [showConfirmCancelar, setShowConfirmCancelar] = useState(false);
  const [trocoInfo, setTrocoInfo] = useState(null);
  const [metodoPagamentoSelecionado, setMetodoPagamentoSelecionado] = useState(null);

  useDriverLocation(user?.uid, online, !!corridaAtiva);

  // GPS
  useEffect(() => {
    let active = true;
    watchLocation(
      (position) => {
        if (!active) return;
        setDriverLat(position.lat);
        setDriverLng(position.lng);
        driverLatRef.current = position.lat;
        driverLngRef.current = position.lng;
      },
      () => {}, { enableHighAccuracy:true, maximumAge:3000, timeout:10000 }
    ).then((controller) => {
      if (active) gpsWatchRef.current = controller;
      else controller.stop?.().catch(() => null);
    }).catch(() => null);
    return () => { active = false; if (gpsWatchRef.current !== null) { gpsWatchRef.current.stop?.().catch(() => null); gpsWatchRef.current = null; } };
  }, []);

  useEffect(() => {
    const bloquear = (e) => { if (corridaAtiva || corridaRecebida) { e.preventDefault(); e.returnValue=""; } };
    window.addEventListener("beforeunload", bloquear);
    return () => window.removeEventListener("beforeunload", bloquear);
  }, [corridaAtiva, corridaRecebida]);

  // Auth
  useEffect(() => {
    const te = setTimeout(() => setLoadingDemorou(true), 8000);
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) { clearTimeout(te); navigate("/login"); return; }
      setUser(u); setFotoURL(u.photoURL || null);
      try {
        const snap = await getDoc(doc(db, "drivers", u.uid));
        if (snap.exists()) {
          const data = snap.data();
          clearTimeout(te);
          if (data.status !== "approved") { navigate("/motorista-analise"); return; }
          const eligibility = await getDriverEligibility();
          if (!eligibility.eligible) { navigate("/cadastro-motorista"); return; }
          setMotorista(data);

          // ── Sempre inicia offline ao abrir o app ──
          // Se estava online, garante que o Firestore também fica offline
          if (primeiroAuthRef.current) {
            primeiroAuthRef.current = false;
            if (data.online === true) {
              setDriverOnlineSecure(false).catch(() => {});
            }
            setOnline(false);
          }

          if (data.qrCodePix) setQrCodeUrl(data.qrCodePix);
          setLoading(false);
          try {
            const [plano, aviso] = await Promise.all([getPlanoMotorista(u.uid), verificarAvisoVencimento(u.uid)]);
            if (!plano) { navigate("/plano-motorista"); return; }
            setPlanoInfo(plano); setBonusInfo(null);
            if (aviso) setAvisoPlano(aviso);
            inicializarNotificacoes("driver").catch(()=>{});
          } catch(e){ console.error(e); }
          iniciarEscutaCorridaAtiva(u.uid);
          return;
        }
        clearTimeout(te);
        navigate("/cadastro-motorista");
      } catch(err){ console.error(err); clearTimeout(te); setLoadingDemorou(true); }
    });
    return () => { clearTimeout(te); unsub(); };
  }, [navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  // Escuta corrida ativa + Pix automático
  const pixPagoAnteriorRef = useRef(false);
  const iniciarEscutaCorridaAtiva = useCallback((uid) => {
    if (unsubAtivaRef.current) { unsubAtivaRef.current(); unsubAtivaRef.current = null; }
    pixPagoAnteriorRef.current = false;
    const q = query(collection(db,"rides"), where("motoristaid","==",uid), where("status","in",["accepted","arrived","in_progress","completion_pending"]), orderBy("criadoEm","desc"));
    unsubAtivaRef.current = onSnapshot(q, (snap) => {
      if (!snap.empty) {
        // Prioriza a corrida mais avançada (in_progress > arrived > accepted)
        const statusPriority = { completion_pending: 4, in_progress: 3, arrived: 2, accepted: 1 };
        const rides = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        rides.sort((a, b) => (statusPriority[b.status] || 0) - (statusPriority[a.status] || 0));
        const corrida = rides[0];
        corridaAtivaRef.current = corrida;
        setCorridaAtiva(corrida);
        // Uma corrida ativa precisa continuar publicando localização mesmo
        // depois que o app é reaberto. O motorista volta a ficar disponível
        // localmente apenas para concluir essa corrida em andamento.
        setOnline(true);
        setDriverOnlineSecure(true).catch(() => {});
        // Próxima corrida pré-aceita (enquanto já está em viagem)
        const proxima = rides.length > 1 ? rides[1] : null;
        proximaCorridaAceitaRef.current = proxima;
        setProximaCorridaAceita(proxima);
        if (corrida.trocoSolicitado) setTrocoInfo({ valor:corrida.trocoSolicitado.valor, mensagem:corrida.trocoSolicitado.mensagem, confirmado:corrida.trocoSolicitado.confirmado||false });
        if (corrida.metodoPagamento) setMetodoPagamentoSelecionado(corrida.metodoPagamento);
        const pixAgora = corrida.pixPago === true;
        if (pixAgora && !pixPagoAnteriorRef.current) {
          setPixRecebido(true);
          setBonusToast({ msg: "📱 Pix recebido do passageiro!", valor: "" });
          setTimeout(() => setBonusToast(null), 4000);
        } else if (pixAgora) { setPixRecebido(true); }
        pixPagoAnteriorRef.current = pixAgora;
      } else { corridaAtivaRef.current = null; setCorridaAtiva(null); proximaCorridaAceitaRef.current = null; setProximaCorridaAceita(null); setTrocoInfo(null); setPixRecebido(false); pixPagoAnteriorRef.current = false; }
    });
  }, []);

  // Escuta corridas pendentes
  useEffect(() => {
    if (!online || !user) {
      if (unsubPendentesRef.current) { unsubPendentesRef.current(); unsubPendentesRef.current = null; }
      clearInterval(timerRef.current);
      return;
    }
    if (unsubPendentesRef.current) { unsubPendentesRef.current(); unsubPendentesRef.current = null; }
    unsubPendentesRef.current = escutarCorridasPendentes((corridas) => {
      if (corridaRecebidaRef.current && !corridas.find(c => c.id === corridaRecebidaRef.current.id)) {
        corridaRecebidaRef.current = null; setCorridaRecebida(null); clearInterval(timerRef.current); return;
      }
      // Permite receber próxima corrida apenas quando já está em viagem (passageiro no carro)
      const emViagem = corridaAtivaRef.current?.status === "in_progress";
      const podeOferecer = !corridaAtivaRef.current || (emViagem && !proximaCorridaAceitaRef.current);
      if (corridas.length > 0 && podeOferecer && !corridaRecebidaRef.current) {
        corridaRecebidaRef.current = corridas[0]; setCorridaRecebida(corridas[0]); setTempoRestante(30);
        clearInterval(timerRef.current);
        if (sons) tocarSomAlerta();
        timerRef.current = setInterval(() => {
          setTempoRestante(t => { if (t <= 1) { clearInterval(timerRef.current); corridaRecebidaRef.current = null; setCorridaRecebida(null); return 30; } return t-1; });
        }, 1000);
      } else if (corridas.length === 0) { corridaRecebidaRef.current = null; setCorridaRecebida(null); clearInterval(timerRef.current); }
    }, driverLatRef.current, driverLngRef.current);
    return () => { if (unsubPendentesRef.current) { unsubPendentesRef.current(); unsubPendentesRef.current = null; } clearInterval(timerRef.current); };
  }, [online, user, sons]); // eslint-disable-line react-hooks/exhaustive-deps

  // Cronômetro
  useEffect(() => {
    let iv;
    if (online && tempoInicioOnline) {
      iv = setInterval(() => {
        const d = Math.floor((Date.now()-tempoInicioOnline)/1000);
        setTempoDisplay(String(Math.floor(d/3600)).padStart(2,"0")+":"+String(Math.floor((d%3600)/60)).padStart(2,"0")+":"+String(d%60).padStart(2,"0"));
      }, 1000);
    } else setTempoDisplay("00:00:00");
    return () => clearInterval(iv);
  }, [online, tempoInicioOnline]);

  const toggleOnline = async () => {
    if (!user) return;
    const n = !online;
    try {
      await setDriverOnlineSecure(n);
      setOnline(n);
      if (n) setTempoInicioOnline(Date.now());
      else setTempoInicioOnline(null);
    } catch (error) {
      console.error("Falha ao alterar disponibilidade", error);
      setSavedMsg("Seu cadastro ainda não está liberado para operar.");
      setTimeout(() => setSavedMsg(""), 4000);
    }
  };

  const logout = async () => {
    if (online) await setDriverOnlineSecure(false).catch(() => {});
    if (unsubAtivaRef.current) { unsubAtivaRef.current(); unsubAtivaRef.current = null; }
    if (unsubPendentesRef.current) { unsubPendentesRef.current(); unsubPendentesRef.current = null; }
    clearInterval(timerRef.current);
    await limparTokenNotificacoes("driver");
    await signOut(auth);
    clearAuthScopedClientState();
    navigate("/login");
  };

  const handleAceitar = async () => {
    if (!corridaRecebida || aceitando) return;
    setAceitando(true); clearInterval(timerRef.current);
    const eraEmViagem = corridaAtivaRef.current?.status === "in_progress";
    try {
      await aceitarCorrida(corridaRecebida.id, user.uid);
      corridaRecebidaRef.current = null; setCorridaRecebida(null);
      if (eraEmViagem) {
        setBonusToast({ msg: "🔜 Próxima corrida reservada!", valor: "" });
        setTimeout(() => setBonusToast(null), 3500);
      }
    } catch(err) {
      console.error(err);
      setBonusToast({ msg: "❌ " + (err.message || "Erro ao aceitar corrida"), valor: "" });
      setTimeout(() => setBonusToast(null), 3500);
    }
    setAceitando(false);
  };

  const handleRecusar = () => {
    clearInterval(timerRef.current);
    corridaRecebidaRef.current = null; setCorridaRecebida(null);
  };

  const handleCancelarCorrida = async () => {
    if (!corridaAtiva || cancelando) return;
    setCancelando(true);
    try {
      await cancelarCorrida(corridaAtiva.id, "motorista");
      setShowConfirmCancelar(false); setMetodoPagamentoSelecionado(null); setPixRecebido(false);
    } catch(err){ console.error(err); }
    setCancelando(false);
  };

  const handleConfirmarPagamento = async (metodo, dadosPag) => {
    if (!corridaAtiva) return;
    try {
      await atualizarMetodoPagamento(corridaAtiva.id, metodo, dadosPag);
      setMetodoPagamentoSelecionado(metodo); setShowPaymentSelector(false);
      setSavedMsg(`Pagamento via ${metodo === "dinheiro" ? "dinheiro" : "PIX"} confirmado ✓`);
      setTimeout(() => setSavedMsg(""), 3000);
    } catch(err){ console.error(err); }
  };

  const handleConfirmarTroco = async () => {
    if (!corridaAtiva || !trocoInfo) return;
    try {
      await updateDoc(doc(db,"rides",corridaAtiva.id), { "trocoSolicitado.confirmado":true, "trocoSolicitado.confirmadoEm":new Date().toISOString() });
      setTrocoInfo(prev => ({ ...prev, confirmado:true }));
      setSavedMsg(`Troco de R$ ${trocoInfo.valor.toFixed(2)} confirmado ✓`);
      setTimeout(() => setSavedMsg(""), 3000);
    } catch(err){ console.error(err); }
  };

  const handleCheguei = async () => {
    if (!corridaAtiva) return;
    try { await chegouNoPassageiro(corridaAtiva.id); } catch(e){ console.error(e); }
  };

  const handleTogglePixRecebido = async () => {
    if (!corridaAtiva) return;
    const novo = !pixRecebido;
    try {
      await updateDoc(doc(db,"rides",corridaAtiva.id), {
        pixPago: novo,
        pixPagoEm: novo ? new Date().toISOString() : null,
      });
      setPixRecebido(novo);
    } catch(e) {
      console.error("Erro ao confirmar Pix:", e);
      setSavedMsg("⚠️ Erro ao confirmar Pix. Tente novamente.");
      setTimeout(() => setSavedMsg(""), 3000);
    }
  };

  const handleConcluir = async () => {
    if (!corridaAtiva) return;
    if (!metodoPagamentoSelecionado) { setShowPaymentSelector(true); return; }
    if (metodoPagamentoSelecionado === "pix" && !pixRecebido) {
      try {
        const snap = await getDoc(doc(db,"rides",corridaAtiva.id));
        if (snap.exists() && snap.data().pixPago === true) setPixRecebido(true);
        else { setSavedMsg("⚠️ Aguardando confirmação do Pix do passageiro"); setTimeout(()=>setSavedMsg(""),3500); return; }
      } catch(e){ setSavedMsg("⚠️ Confirme o recebimento do Pix antes de concluir"); setTimeout(()=>setSavedMsg(""),3000); return; }
    }
    try { await concluirCorrida(corridaAtiva.id); } catch(e) {
      console.error("Erro ao concluir corrida:", e);
      setSavedMsg("❌ Erro ao concluir corrida. Tente novamente.");
      setTimeout(() => setSavedMsg(""), 3000);
      return;
    }
    const valorBruto = corridaAtiva.valorMotorista || corridaAtiva.valor || 0;
    const distancia = corridaAtiva.distanciaKm || corridaAtiva.dadosCorrida?.distanciaKm || 0;
    setDadosGanhos({ valorBruto, bonusExtra:0, metodo:metodoPagamentoSelecionado, distancia, passageiroNome:corridaAtiva.passageiroNome, destino:corridaAtiva.destino?.nome||"Destino" });
    setCorridaCompletada({ rideId:corridaAtiva.id, passageiroId:corridaAtiva.passageiroId, passageiroNome:corridaAtiva.passageiroNome, passageiroFoto:corridaAtiva.passageiroFoto });
    setMetodoPagamentoSelecionado(null); setPixRecebido(false); setShowGanhos(true);
  };

  const handleIniciar = async () => { if (!corridaAtiva) return; try { await iniciarCorrida(corridaAtiva.id); } catch(e){ console.error(e); } };
  const handleSubmitRating = async ({ estrelas, elogios, comentario }) => { if (!corridaCompletada) return; await avaliarPassageiro({ rideId:corridaCompletada.rideId, passageiroId:corridaCompletada.passageiroId, estrelas, elogios, comentario }); };

  const handleFotoChange = async (e) => {
    const file = e.target.files[0];
    // Reset input para permitir selecionar o mesmo arquivo novamente
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (!file || !user) return;

    if (!file.type.startsWith("image/")) {
      setSavedMsg("❌ Selecione uma imagem (JPG, PNG)");
      setTimeout(() => setSavedMsg(""), 4000);
      return;
    }

    setUploadingFoto(true);
    setSavedMsg("");
    try {
      // Comprime antes de subir — resolve falhas por arquivo muito grande
      const blob = await comprimirImagemDriver(file);
      const storage = getStorage();
      const sr = ref(storage, "profile_photos/" + user.uid + ".jpg");
      await uploadBytes(sr, blob, { contentType: "image/jpeg" });
      const url = await getDownloadURL(sr);
      await updateProfile(user, { photoURL: url });
      await updateDoc(doc(db, "drivers", user.uid), { photoURL: url });
      setFotoURL(url);
      setSavedMsg("Foto atualizada! ✓");
      setTimeout(() => setSavedMsg(""), 3000);
    } catch (err) {
      console.error("Erro ao salvar foto:", err);
      setSavedMsg("❌ Erro ao salvar foto. Tente novamente.");
      setTimeout(() => setSavedMsg(""), 4000);
    }
    setUploadingFoto(false);
  };

  const handleQrCodeChange = async (e) => {
    const file = e.target.files[0]; if (!file || !user) return;
    // Valida tipo e tamanho (max 5MB)
    if (!file.type.startsWith("image/")) { setSavedMsg("❌ Envie uma imagem (PNG, JPG)"); setTimeout(()=>setSavedMsg(""),4000); return; }
    if (file.size > 5 * 1024 * 1024) { setSavedMsg("❌ Imagem muito grande (máx 5MB)"); setTimeout(()=>setSavedMsg(""),4000); return; }
    setUploadingQr(true); setSavedMsg("");
    try {
      const storage = getStorage(); const sr = ref(storage,`qr_codes/${user.uid}.png`);
      await uploadBytes(sr, file); const url = await getDownloadURL(sr);
      await updateDoc(doc(db,"drivers",user.uid), { qrCodePix:url });
      setQrCodeUrl(url); setSavedMsg("✓ QR Code Pix salvo!"); setTimeout(()=>setSavedMsg(""),3000);
    } catch(err){
      console.error(err);
      if (err.code === "storage/unauthorized") setSavedMsg("❌ Sem permissão. Contate o suporte.");
      else if (err.code === "storage/canceled") setSavedMsg("❌ Upload cancelado.");
      else setSavedMsg("❌ Erro ao salvar. Tente novamente.");
      setTimeout(()=>setSavedMsg(""),5000);
    }
    setUploadingQr(false);
    if (qrInputRef.current) qrInputRef.current.value = "";
  };

  const handleMigrarFlex = async () => {
    if (!user) return;
    await updateDriverPlanChoice("flex");
    setPlanoInfo(await getPlanoMotorista(user.uid)); setAvisoPlano(null);
  };

  if (loading) {
    return (
      <div style={{ height:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", background:"#0a0e1a", gap:16 }}>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        <div style={{ width:36, height:36, borderRadius:"50%", border:"3px solid rgba(255,255,255,0.1)", borderTopColor:"#a855f7", animation:"spin 0.8s linear infinite" }} />
        <p style={{ color:"rgba(255,255,255,0.4)", fontSize:14 }}>Verificando conta...</p>
        {loadingDemorou && (
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:10, marginTop:16, padding:"16px 24px", background:"rgba(255,255,255,0.05)", borderRadius:12 }}>
            <p style={{ color:"rgba(255,255,255,0.4)", fontSize:13, textAlign:"center" }}>Isso está demorando mais que o esperado.</p>
            <button onClick={()=>navigate("/cadastro-motorista")} style={{ padding:"10px 20px", borderRadius:20, background:"linear-gradient(135deg,#7c3aed,#a855f7)", border:"none", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", width:"100%" }}>Completar cadastro</button>
            <button onClick={logout} style={{ padding:"10px 20px", borderRadius:20, background:"transparent", border:"1px solid rgba(255,255,255,0.15)", color:"rgba(255,255,255,0.5)", fontSize:13, cursor:"pointer", width:"100%" }}>Sair</button>
          </div>
        )}
      </div>
    );
  }

  const nomeMotorista = (motorista?.nome) || "Motorista";
  const primeiroNome = nomeMotorista.split(" ")[0];
  const hora = new Date().getHours();
  const saudacao = hora < 12 ? "Bom dia" : hora < 18 ? "Boa tarde" : "Boa noite";
  const marcaModelo = motorista ? (motorista.marca + " " + motorista.modelo) : "";
  const placa = motorista?.placa || "—";
  const cidade = motorista?.cidade || "—";
  const estado = motorista?.estado || "";
  const avaliacao = motorista?.avaliacao || 5.0;
  const navAlvo = corridaAtiva
    ? (corridaAtiva.status === "in_progress" ? { lat:corridaAtiva.destino?.lat, lng:corridaAtiva.destino?.lng } : { lat:corridaAtiva.origem?.lat, lng:corridaAtiva.origem?.lng })
    : null;

  return (
    <div className="driver-home-screen" data-driver-tab={tab} style={s.root}>
      <style>{`
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
        @keyframes slideUp{from{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.6}}
        @keyframes toastIn{from{opacity:0;transform:translateY(-20px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}
        *{box-sizing:border-box} ::-webkit-scrollbar{width:0}
        .tab-btn:active{transform:scale(0.95)} .setting-row:active{background:rgba(255,255,255,0.06)!important}
      `}</style>

      {bonusToast && (
        <div style={{ position:"fixed", top:56, left:"50%", transform:"translateX(-50%)", zIndex:99999, background:"linear-gradient(135deg,#16a34a,#22c55e)", borderRadius:50, padding:"12px 20px", display:"flex", alignItems:"center", gap:8, boxShadow:"0 8px 24px rgba(34,197,94,0.4)", animation:"toastIn 0.4s ease", whiteSpace:"nowrap" }}>
          <span style={{ fontSize:13, color:"#fff", fontWeight:600 }}>{bonusToast.msg}</span>
          <span style={{ fontSize:15, color:"#fff", fontWeight:800 }}>{bonusToast.valor}</span>
        </div>
      )}

      {savedMsg && (
        <div style={{ position:"fixed", top:56, left:"50%", transform:"translateX(-50%)", zIndex:99999, background:"rgba(0,0,0,0.8)", backdropFilter:"blur(8px)", borderRadius:50, padding:"10px 20px", display:"flex", alignItems:"center", gap:8, animation:"toastIn 0.4s ease" }}>
          <span style={{ fontSize:13, color:"#22c55e", fontWeight:600 }}>{savedMsg}</span>
        </div>
      )}

      {showConfirmCancelar && (
        <div style={{ position:"fixed", inset:0, zIndex:99999, background:"rgba(0,0,0,0.7)", backdropFilter:"blur(4px)", display:"flex", alignItems:"center", justifyContent:"center", padding:"0 24px" }}>
          <div style={{ background:"#0d1527", borderRadius:20, padding:"24px 20px", width:"100%", maxWidth:340, border:"1px solid rgba(255,255,255,0.08)" }}>
            <div style={{ textAlign:"center", marginBottom:20 }}>
              <div style={{ fontSize:40, marginBottom:12 }}>⚠️</div>
              <p style={{ color:"#fff", fontWeight:700, fontSize:16, margin:"0 0 8px" }}>Cancelar corrida?</p>
              <p style={{ color:"rgba(255,255,255,0.45)", fontSize:13, margin:0, lineHeight:1.6 }}>O passageiro será notificado. Cancelamentos frequentes podem afetar sua avaliação.</p>
            </div>
            <div style={{ display:"flex", gap:12 }}>
              <button onClick={()=>setShowConfirmCancelar(false)} style={{ flex:1, padding:"13px", borderRadius:12, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)", color:"rgba(255,255,255,0.6)", fontSize:14, fontWeight:600, cursor:"pointer" }}>Voltar</button>
              <button onClick={handleCancelarCorrida} disabled={cancelando} style={{ flex:1, padding:"13px", borderRadius:12, background:"rgba(239,68,68,0.15)", border:"1px solid rgba(239,68,68,0.3)", color:"#ef4444", fontSize:14, fontWeight:700, cursor:"pointer" }}>
                {cancelando ? "Cancelando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}

      <input ref={fileInputRef} type="file" accept="image/*" style={{ display:"none" }} onChange={handleFotoChange} />
      <input ref={qrInputRef} type="file" accept="image/*" style={{ display:"none" }} onChange={handleQrCodeChange} />

      {avisoPlano && !corridaAtiva && (
        <div style={{ position:"fixed", top:0, left:"50%", transform:"translateX(-50%)", width:"100%", maxWidth:480, zIndex:9998, background:"#0d1527", borderBottom:"1px solid rgba(255,255,255,0.08)", padding:"12px 16px" }}>
          <p style={{ fontSize:13, fontWeight:700, color:avisoPlano.tipo==="venceu"?"#ef4444":"#f59e0b", margin:"0 0 4px" }}>{avisoPlano.tipo==="venceu"?"❌ Seu plano venceu":`⚠️ Plano vence em ${avisoPlano.diasRestantes} dia${avisoPlano.diasRestantes!==1?"s":""}`}</p>
          <p style={{ fontSize:12, color:"rgba(255,255,255,0.5)", margin:"0 0 10px" }}>{avisoPlano.tipo==="venceu"?"Escolha um plano para continuar recebendo corridas.":"Renove ou migre para o Plano Flex."}</p>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={handleMigrarFlex} style={{ flex:1, padding:"9px", borderRadius:10, background:"rgba(245,158,11,0.15)", border:"1px solid rgba(245,158,11,0.3)", color:"#f59e0b", fontSize:12, fontWeight:700, cursor:"pointer" }}>⚡ Ir para Flex</button>
            <button onClick={()=>navigate("/plano-motorista")} style={{ flex:1, padding:"9px", borderRadius:10, background:"linear-gradient(135deg,#7c3aed,#a855f7)", border:"none", color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer" }}>Renovar plano</button>
          </div>
        </div>
      )}

      <BannerTrialDiario planoInfo={planoInfo} />
      <CobrancaFlexBanner planoInfo={planoInfo} driverUid={user?.uid} bloqueado={motorista?.bloqueado} />

      {showRating && corridaCompletada && (
        <RatingModal
          tipo="passageiro"
          nome={corridaCompletada.passageiroNome || "Passageiro"}
          foto={corridaCompletada.passageiroFoto || ""}
          rideId={corridaCompletada.rideId}
          reportadoPorId={user?.uid}
          onClose={() => { setShowRating(false); setCorridaCompletada(null); }}
          onSubmit={handleSubmitRating}
        />
      )}

      {corridaAtiva && (
        <SOSButton rideId={corridaAtiva.id} userType="driver" lat={driverLat} lng={driverLng} />
      )}

      {showGanhos && dadosGanhos && (
        <ModalGanhos dados={dadosGanhos} onFechar={()=>{ setShowGanhos(false); setShowRating(true); }} />
      )}

      {showChat && corridaAtiva && (
        <ChatCorrida rideId={corridaAtiva.id} tipoUsuario="driver" nomeOutro={corridaAtiva.passageiroNome||"Passageiro"} onClose={()=>setShowChat(false)} />
      )}

      {showPaymentSelector && corridaAtiva && (
        <PaymentSelector valorCorrida={corridaAtiva.valor} onConfirmar={handleConfirmarPagamento} onVoltar={()=>setShowPaymentSelector(false)} />
      )}

      {/* Modal corrida recebida — só fullscreen quando NÃO há corrida ativa */}
      {corridaRecebida && !corridaAtiva && (
        <div style={{ position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.75)", backdropFilter:"blur(4px)", display:"flex", alignItems:"flex-end" }}>
          <div style={{ width:"100%", maxWidth:480, margin:"0 auto", background:"#0d1527", borderRadius:"28px 28px 0 0", padding:"24px 20px 40px", animation:"slideUp 0.35s ease", border:"1px solid rgba(255,255,255,0.08)", borderBottom:"none" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
              <div style={{ width:40, height:4, background:"rgba(255,255,255,0.15)", borderRadius:2 }} />
              <div style={{ width:48, height:48, borderRadius:"50%", background:tempoRestante>10?"rgba(34,197,94,0.15)":"rgba(239,68,68,0.15)", border:`2px solid ${tempoRestante>10?"#22c55e":"#ef4444"}`, display:"flex", alignItems:"center", justifyContent:"center" }}>
                <span style={{ fontSize:20, fontWeight:800, color:tempoRestante>10?"#22c55e":"#ef4444" }}>{tempoRestante}</span>
              </div>
              <button onClick={handleRecusar} style={{ width:36, height:36, borderRadius:"50%", border:"none", background:"rgba(255,255,255,0.07)", color:"rgba(255,255,255,0.4)", fontSize:18, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>✕</button>
            </div>
            <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:16 }}>
              {corridaRecebida.passageiroFoto ? (
                <img src={corridaRecebida.passageiroFoto} alt="" style={{ width:48, height:48, borderRadius:"50%", objectFit:"cover", border:"2px solid rgba(168,85,247,0.4)", flexShrink:0 }}/>
              ) : (
                <div style={{ width:48, height:48, borderRadius:"50%", background:"linear-gradient(135deg,#ec4899,#7c3aed)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, fontWeight:700, color:"#fff", flexShrink:0 }}>
                  {(corridaRecebida.passageiroNome||"P").charAt(0).toUpperCase()}
                </div>
              )}
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                  <p style={{ color:"#fff", fontWeight:700, fontSize:16, margin:0 }}>{corridaRecebida.passageiroNome||"Passageiro"}</p>
                  {corridaRecebida.passageiroVerificado && (
                    <div style={{ display:"inline-flex", alignItems:"center", gap:3, background:"rgba(34,197,94,0.12)", border:"1px solid rgba(34,197,94,0.3)", borderRadius:20, padding:"2px 8px" }}>
                      <svg width="9" height="9" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                      <span style={{ color:"#22c55e", fontSize:10, fontWeight:700 }}>Verificado</span>
                    </div>
                  )}
                </div>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:2 }}>
                  <p style={{ color:"rgba(255,255,255,0.4)", fontSize:13, margin:0 }}>{corridaRecebida.categoria==="elite"?"Zuno Elite":"Zuno Movel"}</p>
                  {corridaRecebida.passageiroAvaliacao && (
                    <div style={{ display:"flex", alignItems:"center", gap:3, background:"rgba(245,158,11,0.12)", border:"1px solid rgba(245,158,11,0.25)", borderRadius:20, padding:"2px 8px" }}>
                      <span style={{ color:"#f59e0b", fontSize:11 }}>★</span>
                      <span style={{ color:"#f59e0b", fontSize:12, fontWeight:700 }}>{Number(corridaRecebida.passageiroAvaliacao).toFixed(1)}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {(() => {
              const metodo = corridaRecebida.metodoPagamento||"dinheiro";
              const pag = iconePagamento(metodo);
              const rgb = metodo==="dinheiro"?"34,197,94":metodo==="pix"?"6,182,212":"59,130,246";
              return (
                <div style={{ marginBottom:12, padding:"12px 14px", background:`rgba(${rgb},0.1)`, border:`1px solid rgba(${rgb},0.3)`, borderRadius:12 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ fontSize:20 }}>{pag.icon}</span>
                    <div style={{ flex:1 }}>
                      <p style={{ color:pag.cor, fontWeight:700, fontSize:13, margin:0 }}>Pagamento: {pag.label}</p>
                      {corridaRecebida.precisaTroco && corridaRecebida.trocoValor && (
                        <p style={{ color:"#f59e0b", fontSize:12, fontWeight:700, margin:"4px 0 0", animation:"shake 0.5s ease" }}>⚠️ Precisa de troco para R$ {Number(corridaRecebida.trocoValor).toFixed(2)}</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })()}
            {corridaRecebida.isSurge && (
              <div style={{ marginBottom:12, padding:"8px 14px", background:"rgba(245,158,11,0.12)", border:"1px solid rgba(245,158,11,0.35)", borderRadius:12, display:"flex", alignItems:"center", gap:10 }}>
                <span style={{ fontSize:18 }}>⚡</span>
                <div>
                  <p style={{ color:"#f59e0b", fontWeight:800, fontSize:13, margin:0 }}>Alta demanda — {corridaRecebida.surgeLabel}</p>
                  <p style={{ color:"rgba(245,158,11,0.65)", fontSize:11, margin:0 }}>Multiplicador {corridaRecebida.surgeFactor?.toFixed(2)}x — você ganha mais!</p>
                </div>
              </div>
            )}
            <div style={{ padding:"14px", background:"rgba(255,255,255,0.04)", borderRadius:14, border:"1px solid rgba(255,255,255,0.07)", marginBottom:20 }}>
              <div style={{ display:"flex", gap:16, justifyContent:"space-around", marginBottom:10 }}>
                {[["Distância", corridaRecebida.distanciaKm?`${Number(corridaRecebida.distanciaKm).toFixed(1)} km`:"—", "#fff"],
                  ["Tempo", corridaRecebida.tempoMin?`${corridaRecebida.tempoMin} min`:"—", "#fff"],
                  ["Valor", `R$ ${Number(corridaRecebida.valorMotorista||corridaRecebida.valor||0).toFixed(2)}`, corridaRecebida.isSurge?"#f59e0b":"#22c55e"]
                ].map(([label,val,cor],i) => (
                  <React.Fragment key={i}>
                    {i>0 && <div style={{ width:1, background:"rgba(255,255,255,0.07)" }} />}
                    <div style={{ textAlign:"center" }}>
                      <p style={{ color:"rgba(255,255,255,0.35)", fontSize:10, letterSpacing:0.8, margin:"0 0 2px", textTransform:"uppercase" }}>{label}</p>
                      <p style={{ color:cor, fontSize:16, fontWeight: i===2?800:700, margin:0 }}>{val}</p>
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <div style={{ display:"flex", alignItems:"flex-start", gap:8 }}>
                <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:2, paddingTop:3 }}>
                  <div style={{ width:8, height:8, borderRadius:"50%", background:"#22c55e" }} />
                  <div style={{ width:1, height:20, background:"rgba(255,255,255,0.1)" }} />
                  <div style={{ width:8, height:8, borderRadius:2, background:"#ef4444" }} />
                </div>
                <div style={{ flex:1 }}>
                  <p style={{ color:"rgba(255,255,255,0.6)", fontSize:12, margin:"0 0 18px", lineHeight:1.4 }}>{corridaRecebida.origem?.endereco||"Ponto de embarque"}</p>
                  <p style={{ color:"rgba(255,255,255,0.6)", fontSize:12, margin:0, lineHeight:1.4 }}>{corridaRecebida.destino?.nome||corridaRecebida.destino?.endereco||"Destino"}</p>
                </div>
              </div>
            </div>
            <button onClick={handleAceitar} disabled={aceitando} style={{ width:"100%", padding:"16px", borderRadius:16, border:"none", background:"linear-gradient(135deg,#16a34a,#22c55e)", color:"#fff", fontSize:16, fontWeight:800, cursor:aceitando?"not-allowed":"pointer", opacity:aceitando?0.7:1 }}>
              {aceitando?"Aceitando...":"✓ Aceitar corrida"}
            </button>
          </div>
        </div>
      )}

      <div className="driver-main-content" style={{ ...s.content, overflow:tab==="home"?"hidden":"auto" }}>
        {tab==="home" && <TabHome
          motorista={motorista} online={online} toggleOnline={toggleOnline} tempoDisplay={tempoDisplay}
          saudacao={saudacao} primeiroNome={primeiroNome} marcaModelo={marcaModelo}
          placa={placa} fotoURL={fotoURL} logout={logout}
          corridaAtiva={corridaAtiva} proximaCorridaAceita={proximaCorridaAceita}
          corridaRecebidaEmViagem={corridaAtiva ? corridaRecebida : null}
          tempoRestanteEmViagem={tempoRestante} aceitandoEmViagem={aceitando}
          onAceitarEmViagem={handleAceitar} onRecusarEmViagem={handleRecusar}
          handleIniciar={handleIniciar} handleConcluir={handleConcluir} handleCheguei={handleCheguei}
          onCancelarCorrida={()=>setShowConfirmCancelar(true)}
          bonusInfo={bonusInfo} planoInfo={planoInfo}
          showChat={showChat} setShowChat={setShowChat}
          showPaymentSelector={showPaymentSelector} setShowPaymentSelector={setShowPaymentSelector}
          trocoInfo={trocoInfo} handleConfirmarTroco={handleConfirmarTroco}
          metodoPagamentoSelecionado={metodoPagamentoSelecionado}
          driverLat={driverLat} driverLng={driverLng} navAlvo={navAlvo}
          pixRecebido={pixRecebido} onTogglePixRecebido={handleTogglePixRecebido}
        />}
        {tab==="corridas" && <TabCorridas uid={user?.uid} cidadeMotorista={motorista?.cidade} />}
        {tab==="perfil" && <TabPerfil
          motorista={motorista} user={user} fotoURL={fotoURL} uploadingFoto={uploadingFoto}
          handleFotoChange={handleFotoChange} fileInputRef={fileInputRef} savedMsg={savedMsg}
          nomeMotorista={nomeMotorista} avaliacao={avaliacao} placa={placa} cidade={cidade}
          estado={estado} navigate={navigate} qrCodeUrl={qrCodeUrl} uploadingQr={uploadingQr} qrInputRef={qrInputRef}
        />}
        {tab==="config" && <TabConfig notificacoes={notificacoes} setNotificacoes={setNotificacoes} sons={sons} setSons={setSons} logout={logout} navigate={navigate} planoInfo={planoInfo} handleMigrarFlex={handleMigrarFlex} />}
      </div>

      <nav className="driver-bottom-nav" style={s.bottomNav}>
        {[{key:"home",label:"Início",Icon:IconHome},{key:"corridas",label:"Corridas",Icon:IconRides},{key:"perfil",label:"Perfil",Icon:IconProfile},{key:"config",label:"Config.",Icon:IconSettings}].map(({key,label,Icon})=>(
          <button key={key} className="tab-btn" onClick={()=>setTab(key)} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:3, background:"transparent", border:"none", cursor:"pointer", padding:"10px 4px 8px", position:"relative", transition:"all 0.2s" }}>
            {tab===key && (
              <div style={{ position:"absolute", top:0, left:"50%", transform:"translateX(-50%)", width:32, height:2.5, borderRadius:2, background:"linear-gradient(90deg,#7c3aed,#c084fc)" }} />
            )}
            <div style={{ transition:"transform 0.25s cubic-bezier(0.34,1.56,0.64,1)", transform:tab===key?"scale(1.15)":"scale(1)", padding:"4px 10px", borderRadius:12, background:tab===key?"rgba(168,85,247,0.12)":"transparent", transition2:"background 0.2s" }}>
              <Icon active={tab===key} />
            </div>
            <span style={{ fontSize:10, fontWeight:tab===key?700:500, color:tab===key?"#c084fc":"rgba(255,255,255,0.32)", letterSpacing:0.4, marginTop:1 }}>{label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

// ─── ABA HOME ─────────────────────────────────────────────────
// painelAberto=false  → barra compacta: saudação + botão ONLINE + avatar
// painelAberto=true   → painel expandido: stats + plano + botão ONLINE grande
function TabHome({ motorista, online, toggleOnline, tempoDisplay, saudacao, primeiroNome, marcaModelo, placa, fotoURL, logout, corridaAtiva, proximaCorridaAceita, corridaRecebidaEmViagem, tempoRestanteEmViagem, aceitandoEmViagem, onAceitarEmViagem, onRecusarEmViagem, handleIniciar, handleConcluir, handleCheguei, onCancelarCorrida, bonusInfo, planoInfo, showChat, setShowChat, showPaymentSelector, setShowPaymentSelector, trocoInfo, handleConfirmarTroco, metodoPagamentoSelecionado, driverLat, driverLng, navAlvo, pixRecebido, onTogglePixRecebido }) {
  const [painelAberto, setPainelAberto] = React.useState(false);
  const [mostrarZonas, setMostrarZonas] = React.useState(false);

  // Abre o painel automaticamente quando uma corrida é aceita
  React.useEffect(() => {
    if (corridaAtiva) setPainelAberto(true);
  }, [corridaAtiva]);

  return (
    <div style={{ position:"relative", height:"100vh", overflow:"hidden", background:"#e8eff5" }}>
      {/* MAPA — ocupa tela toda */}
      <div style={{ position:"absolute", inset:0 }}>
        <MapaPrincipal driverLat={driverLat} driverLng={driverLng} online={online} mostrarZonas={mostrarZonas} navAlvo={navAlvo} />
      </div>

      {/* Header flutuante */}
      <div style={{ position:"absolute", top:0, left:0, right:0, zIndex:30, padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ background:"rgba(0,0,0,0.75)", backdropFilter:"blur(8px)", borderRadius:24, padding:"8px 16px", display:"flex", alignItems:"center", gap:6 }}>
          <span style={{ color:"#22c55e", fontSize:13, fontWeight:700 }}>R$</span>
          <span style={{ color:"white", fontSize:18, fontWeight:800 }}>{(bonusInfo?.bonusHoje||0).toFixed(2)}</span>
          <span style={{ color:"rgba(255,255,255,0.5)", fontSize:11 }}>hoje</span>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          {/* Botão zonas quentes */}
          {!corridaAtiva && (
            <button onClick={() => setMostrarZonas(z => !z)} style={{ background: mostrarZonas ? "rgba(239,68,68,0.85)" : "rgba(0,0,0,0.75)", backdropFilter:"blur(8px)", border:"none", borderRadius:20, padding:"7px 12px", color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", gap:5 }}>
              🔥 {mostrarZonas ? "Ocultar" : "Zonas"}
            </button>
          )}
          <div style={{ background:"rgba(0,0,0,0.75)", backdropFilter:"blur(8px)", borderRadius:24, padding:"6px 12px", display:"flex", alignItems:"center", gap:8 }}>
            <Avatar fotoURL={fotoURL} nome={primeiroNome} size={28} fontSize={12} />
            <span style={{ color:"white", fontSize:12, fontWeight:600 }}>{primeiroNome}</span>
          </div>
        </div>
      </div>

      {/* Badge offline */}
      {!online && !corridaAtiva && (
        <div style={{ position:"absolute", top:"42%", left:"50%", transform:"translate(-50%,-50%)", zIndex:20, pointerEvents:"none" }}>
          <div style={{ background:"rgba(0,0,0,0.7)", backdropFilter:"blur(8px)", borderRadius:20, padding:"6px 16px", border:"1px solid rgba(255,255,255,0.15)" }}>
            <span style={{ color:"rgba(255,255,255,0.7)", fontSize:12, fontWeight:600 }}>Você está offline</span>
          </div>
        </div>
      )}

      {/* ── PAINEL INFERIOR ── */}
      <div style={{ position:"absolute", bottom:0, left:0, right:0, zIndex:30 }}>

        {corridaAtiva ? (
          /* ══ CORRIDA ATIVA ══ */
          <div style={{ background:"#0a0e1a", borderRadius:"20px 20px 0 0", borderTop:"2px solid rgba(168,85,247,0.3)" }}>
            {/* Área clicável — expand/recolhe painel secundário */}
            <div style={{ padding:"14px 16px 10px", cursor:"pointer" }} onClick={()=>setPainelAberto(p=>!p)}>
              <div style={{ width:40, height:4, background:"rgba(255,255,255,0.12)", borderRadius:2, margin:"0 auto 12px" }} />
              <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:10 }}>
                {corridaAtiva.passageiroFoto ? (
                  <img src={corridaAtiva.passageiroFoto} alt="" style={{ width:40, height:40, borderRadius:"50%", objectFit:"cover", border:"2px solid rgba(168,85,247,0.4)", flexShrink:0 }}/>
                ) : (
                  <div style={{ width:40, height:40, borderRadius:"50%", background:"linear-gradient(135deg,#ec4899,#7c3aed)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, fontWeight:700, color:"#fff", flexShrink:0 }}>
                    {(corridaAtiva.passageiroNome||"P").charAt(0).toUpperCase()}
                  </div>
                )}
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                    <p style={{ color:"#fff", fontWeight:700, fontSize:14, margin:0 }}>{corridaAtiva.passageiroNome||"Passageiro"}</p>
                    {corridaAtiva.passageiroVerificado && (
                      <div style={{ display:"inline-flex", alignItems:"center", gap:3, background:"rgba(34,197,94,0.12)", border:"1px solid rgba(34,197,94,0.3)", borderRadius:20, padding:"1px 7px" }}>
                        <svg width="8" height="8" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        <span style={{ color:"#22c55e", fontSize:10, fontWeight:700 }}>Verificado</span>
                      </div>
                    )}
                  </div>
                  <p style={{ color:"rgba(255,255,255,0.4)", fontSize:12, margin:"2px 0 0" }}>
                    {corridaAtiva.status==="in_progress"?`📍 ${corridaAtiva.destino?.nome||"Destino"}`:corridaAtiva.status==="arrived"?"📍 Você chegou ao passageiro":`📍 ${corridaAtiva.origem?.endereco||"A caminho"}`}
                  </p>
                </div>
                <div style={{ textAlign:"right" }}>
                  <p style={{ color:"#22c55e", fontWeight:800, fontSize:16, margin:0 }}>R$ {Number(corridaAtiva.valorMotorista||corridaAtiva.valor||0).toFixed(2)}</p>
                  <p style={{ color:"rgba(255,255,255,0.3)", fontSize:11, margin:"2px 0 0" }}>{corridaAtiva.metodoPagamento==="pix"?"📱 Pix":corridaAtiva.metodoPagamento==="maquininha"?"💳 Cartão":"💵 Dinheiro"}</p>
                </div>
              </div>
              <ProgressoCorrida corridaAtiva={corridaAtiva} driverLat={driverLat} driverLng={driverLng} />
              {proximaCorridaAceita && (
                <div style={{ marginTop:8, padding:"8px 12px", background:"rgba(34,197,94,0.07)", border:"1px solid rgba(34,197,94,0.22)", borderRadius:12, display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ fontSize:14, flexShrink:0 }}>🔜</span>
                  <div style={{ flex:1, minWidth:0 }}>
                    <p style={{ color:"#22c55e", fontWeight:700, fontSize:11, margin:0, letterSpacing:0.5, textTransform:"uppercase" }}>Próxima corrida reservada</p>
                    <p style={{ color:"rgba(255,255,255,0.55)", fontSize:12, margin:"3px 0 0", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                      {proximaCorridaAceita.passageiroNome}
                    </p>
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:3 }}>
                      <span style={{ color:"#22c55e", fontSize:12, fontWeight:800 }}>R$ {Number(proximaCorridaAceita.valorMotorista||proximaCorridaAceita.valor||0).toFixed(2)}</span>
                      {proximaCorridaAceita.distanciaKm && <span style={{ color:"rgba(255,255,255,0.35)", fontSize:11 }}>· {Number(proximaCorridaAceita.distanciaKm).toFixed(1)} km</span>}
                      {proximaCorridaAceita.tempoMin && <span style={{ color:"rgba(255,255,255,0.35)", fontSize:11 }}>· {proximaCorridaAceita.tempoMin} min</span>}
                    </div>
                  </div>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
              )}
              <p style={{ fontSize:10, color:"rgba(255,255,255,0.2)", textAlign:"center", margin:"4px 0 0", letterSpacing:0.5 }}>
                {painelAberto ? "▲ toque para recolher" : "▼ toque para detalhes"}
              </p>
            </div>

            {/* Conteúdo expandido — secundário */}
            {painelAberto && (
              <div style={{ padding:"4px 16px 8px", maxHeight:"38vh", overflowY:"auto" }}>
                {navAlvo?.lat && navAlvo?.lng && (
                  <div style={{ marginBottom:10 }}>
                    <p style={{ fontSize:10, color:"rgba(255,255,255,0.3)", letterSpacing:1, textTransform:"uppercase", margin:"0 0 6px" }}>{corridaAtiva.status==="in_progress"?"Navegar até o destino":"Navegar até o passageiro"}</p>
                    <BotoesNavegacao lat={navAlvo.lat} lng={navAlvo.lng} />
                  </div>
                )}
                {trocoInfo && !trocoInfo.confirmado && (
                  <div style={{ marginBottom:10, padding:"10px 12px", background:"rgba(245,158,11,0.1)", border:"1px solid rgba(245,158,11,0.3)", borderRadius:12 }}>
                    <p style={{ color:"#f59e0b", fontWeight:700, fontSize:13, margin:"0 0 6px" }}>💰 Troco de R$ {trocoInfo.valor.toFixed(2)}</p>
                    <button onClick={handleConfirmarTroco} style={{ width:"100%", padding:"10px", borderRadius:10, background:"#f59e0b", border:"none", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer" }}>✓ Tenho o troco</button>
                  </div>
                )}
                {metodoPagamentoSelecionado && (
                  <div style={{ marginBottom:8, padding:"8px 12px", background:`rgba(${metodoPagamentoSelecionado==="dinheiro"?"34,197,94":metodoPagamentoSelecionado==="pix"?"6,182,212":"59,130,246"},0.1)`, borderRadius:10, display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ fontSize:14 }}>{iconePagamento(metodoPagamentoSelecionado).icon}</span>
                    <span style={{ fontSize:12, color:iconePagamento(metodoPagamentoSelecionado).cor }}>Pagamento via <strong>{iconePagamento(metodoPagamentoSelecionado).label}</strong></span>
                  </div>
                )}
                <div style={{ display:"flex", gap:8, marginBottom:8 }}>
                  <button onClick={()=>setShowChat(true)} style={{ flex:1, padding:"10px", borderRadius:10, background:"rgba(168,85,247,0.12)", border:"1px solid rgba(168,85,247,0.3)", color:"#a855f7", fontSize:13, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
                    <IconChat /> Chat
                  </button>
                  {!metodoPagamentoSelecionado && (
                    <button onClick={()=>setShowPaymentSelector(true)} style={{ flex:1, padding:"10px", borderRadius:10, background:"rgba(59,130,246,0.12)", border:"1px solid rgba(59,130,246,0.3)", color:"#3b82f6", fontSize:13, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
                      <IconMoney /> Pagamento
                    </button>
                  )}
                </div>
                {corridaAtiva.status==="in_progress" && metodoPagamentoSelecionado==="pix" && (
                  <div onClick={onTogglePixRecebido} style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", borderRadius:12, marginBottom:8, cursor:"pointer", background:pixRecebido?"rgba(34,197,94,0.1)":"rgba(255,255,255,0.04)", border:`1px solid ${pixRecebido?"rgba(34,197,94,0.3)":"rgba(255,255,255,0.08)"}`, transition:"all 0.2s" }}>
                    <div style={{ width:22, height:22, borderRadius:6, flexShrink:0, background:pixRecebido?"#22c55e":"rgba(255,255,255,0.1)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      {pixRecebido && <svg width="13" height="13" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                    </div>
                    <p style={{ color:pixRecebido?"#22c55e":"rgba(255,255,255,0.5)", fontSize:13, fontWeight:600, margin:0 }}>{pixRecebido?"✓ Pix recebido!":"Confirmar recebimento do Pix"}</p>
                  </div>
                )}
                <button onClick={onCancelarCorrida} style={{ width:"100%", padding:"10px", borderRadius:12, background:"transparent", border:"1px solid rgba(239,68,68,0.2)", color:"rgba(239,68,68,0.6)", fontSize:13, fontWeight:600, cursor:"pointer", marginBottom:4 }}>Cancelar corrida</button>
              </div>
            )}

            {/* ── CARD PRÓXIMA CORRIDA (compacto, sem bloquear mapa) ── */}
            {corridaRecebidaEmViagem && corridaAtiva.status==="in_progress" && (
              <div style={{ margin:"0 16px 8px", borderRadius:16, overflow:"hidden", border:"1px solid rgba(168,85,247,0.35)", background:"rgba(13,21,39,0.97)", animation:"slideUp 0.3s ease" }}>
                {/* Header roxo */}
                <div style={{ background:"linear-gradient(135deg,rgba(124,58,237,0.4),rgba(168,85,247,0.25))", padding:"8px 14px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                    <span style={{ fontSize:13 }}>🔜</span>
                    <span style={{ color:"#c084fc", fontWeight:800, fontSize:11, letterSpacing:0.8, textTransform:"uppercase" }}>Nova corrida disponível</span>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                    <div style={{ width:26, height:26, borderRadius:"50%", background:tempoRestanteEmViagem>10?"rgba(34,197,94,0.15)":"rgba(239,68,68,0.15)", border:`1.5px solid ${tempoRestanteEmViagem>10?"#22c55e":"#ef4444"}`, display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <span style={{ fontSize:11, fontWeight:800, color:tempoRestanteEmViagem>10?"#22c55e":"#ef4444" }}>{tempoRestanteEmViagem}</span>
                    </div>
                    <button onClick={onRecusarEmViagem} style={{ width:26, height:26, borderRadius:"50%", border:"none", background:"rgba(255,255,255,0.07)", color:"rgba(255,255,255,0.4)", fontSize:14, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", padding:0 }}>✕</button>
                  </div>
                </div>
                {/* Info da corrida */}
                <div style={{ padding:"10px 14px", display:"flex", alignItems:"center", gap:10 }}>
                  {corridaRecebidaEmViagem.passageiroFoto ? (
                    <img src={corridaRecebidaEmViagem.passageiroFoto} alt="" style={{ width:36, height:36, borderRadius:"50%", objectFit:"cover", border:"2px solid rgba(168,85,247,0.4)", flexShrink:0 }} />
                  ) : (
                    <div style={{ width:36, height:36, borderRadius:"50%", background:"linear-gradient(135deg,#ec4899,#7c3aed)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:700, color:"#fff", flexShrink:0 }}>
                      {(corridaRecebidaEmViagem.passageiroNome||"P").charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div style={{ flex:1, minWidth:0 }}>
                    <p style={{ color:"#fff", fontWeight:700, fontSize:13, margin:0, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{corridaRecebidaEmViagem.passageiroNome||"Passageiro"}</p>
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:2, flexWrap:"wrap" }}>
                      <span style={{ color:"#22c55e", fontWeight:800, fontSize:13 }}>R$ {Number(corridaRecebidaEmViagem.valorMotorista||corridaRecebidaEmViagem.valor||0).toFixed(2)}</span>
                      {corridaRecebidaEmViagem.distanciaKm && <span style={{ color:"rgba(255,255,255,0.4)", fontSize:12 }}>· {Number(corridaRecebidaEmViagem.distanciaKm).toFixed(1)} km</span>}
                      {corridaRecebidaEmViagem.tempoMin && <span style={{ color:"rgba(255,255,255,0.4)", fontSize:12 }}>· {corridaRecebidaEmViagem.tempoMin} min</span>}
                    </div>
                  </div>
                  <button onClick={onAceitarEmViagem} disabled={aceitandoEmViagem} style={{ flexShrink:0, padding:"9px 16px", borderRadius:12, border:"none", background:"linear-gradient(135deg,#16a34a,#22c55e)", color:"#fff", fontSize:13, fontWeight:800, cursor:aceitandoEmViagem?"not-allowed":"pointer", opacity:aceitandoEmViagem?0.7:1 }}>
                    {aceitandoEmViagem?"...":"✓ Aceitar"}
                  </button>
                </div>
              </div>
            )}

            {/* ── BOTÃO PRIMÁRIO — sempre visível ── */}
            <div style={{ padding:"8px 16px", paddingBottom:"calc(78px + env(safe-area-inset-bottom, 0px))" }}>
              {corridaAtiva.status==="accepted" && (
                <button onClick={handleCheguei} style={{ width:"100%", padding:"15px", borderRadius:14, background:"linear-gradient(135deg,#f59e0b,#d97706)", border:"none", color:"#fff", fontSize:15, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 16px rgba(245,158,11,0.4)" }}>📍 Cheguei ao passageiro</button>
              )}
              {corridaAtiva.status==="arrived" && (
                <button onClick={handleIniciar} style={{ width:"100%", padding:"15px", borderRadius:14, background:"linear-gradient(135deg,#a855f7,#7c3aed)", border:"none", color:"#fff", fontSize:15, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 16px rgba(168,85,247,0.4)" }}>🚦 Iniciar corrida</button>
              )}
              {corridaAtiva.status==="in_progress" && (
                <button onClick={handleConcluir} style={{ width:"100%", padding:"15px", borderRadius:14, background:"linear-gradient(135deg,#22c55e,#16a34a)", border:"none", color:"#fff", fontSize:15, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 16px rgba(34,197,94,0.4)", opacity:metodoPagamentoSelecionado==="pix"&&!pixRecebido?0.55:1 }}>✅ Concluir corrida</button>
              )}
              {corridaAtiva.status==="completion_pending" && (
                <div style={{ width:"100%", padding:"15px", boxSizing:"border-box", borderRadius:14, background:"rgba(59,130,246,.15)", border:"1px solid rgba(59,130,246,.35)", color:"#93c5fd", textAlign:"center", fontSize:14, fontWeight:700 }}>Processando a conclusão com segurança…</div>
              )}
            </div>
          </div>
        ) : (
          /* ══ SEM CORRIDA ATIVA ══ */
          <div style={{ background:"#0d1527", borderRadius:"24px 24px 0 0", padding:"16px 16px 0", paddingBottom:"calc(80px + env(safe-area-inset-bottom, 0px))", borderTop:"1px solid rgba(255,255,255,0.08)" }}>
            {/* Stats — sempre visíveis */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:7, marginBottom:10 }}>
              <StatCard icon="⏱️" label="Online" value={tempoDisplay} sub="hoje" accent="rgba(168,85,247,0.5)" />
              <StatCard icon="💰" label="Ganhos" value={`R$${(bonusInfo?.bonusHoje||0).toFixed(0)}`} sub="hoje" accent="rgba(34,197,94,0.5)" />
              <StatCard icon="🚗" label="Corridas" value={bonusInfo?.corridasHoje||0} sub="hoje" accent="rgba(6,182,212,0.5)" />
            </div>
            {/* Info plano */}
            {planoInfo && (
              <div style={{ padding:"10px 14px", background:"rgba(255,255,255,0.04)", borderRadius:12, border:"1px solid rgba(255,255,255,0.07)", marginBottom:12 }}>
                <p style={{ fontSize:11, color:"rgba(255,255,255,0.35)", margin:"0 0 2px" }}>{planoInfo.plano==="flex"?"⚡ Plano Flex":"💼 Plano Mensalidade"}</p>
                <p style={{ fontSize:13, fontWeight:700, color:"#fff", margin:0 }}>{planoInfo.trialAtivo?`🎁 ${planoInfo.diasRestantes}d grátis restantes`:planoInfo.plano==="flex"?"8% por corrida":"100% por corrida"}</p>
              </div>
            )}
            {/* Botão ONLINE/OFFLINE grande */}
            <button
              onClick={toggleOnline}
              style={{
                width:"100%",
                padding:"16px",
                borderRadius:50,
                border:"none",
                background: online
                  ? "linear-gradient(135deg,#16a34a,#22c55e)"
                  : "linear-gradient(135deg,#7c3aed,#a855f7)",
                color:"#fff",
                fontSize:17,
                fontWeight:800,
                cursor:"pointer",
                marginBottom:16,
                letterSpacing:0.5,
                boxShadow: online
                  ? "0 4px 20px rgba(34,197,94,0.5)"
                  : "0 4px 20px rgba(124,58,237,0.5)",
              }}
            >
              {online ? "● ONLINE" : "● OFFLINE"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── ABA CORRIDAS ─────────────────────────────────────────────
function TabCorridas({ uid, cidadeMotorista }) {
  const [corridas, setCorridas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [periodo, setPeriodo] = useState("semana");
  const [agendadas, setAgendadas] = useState([]);

  useEffect(() => {
    if (!uid) return;
    getHistoricoCorridas(uid, "driver")
      .then(({ corridas: lista }) => { setCorridas(lista); setCarregando(false); })
      .catch(() => setCarregando(false));
    const unsub = escutarAgendadasParaMotorista(cidadeMotorista, setAgendadas);
    return () => unsub();
  }, [uid, cidadeMotorista]);

  const agora = new Date();

  // ── Filtro correto: aplica período a TODAS as corridas (não só concluídas) ──
  const filtradas = corridas.filter(c => {
    const data = c.concluidoEm?.toDate?.() || c.criadoEm?.toDate?.() || null;
    if (!data) return false;
    if (periodo === "hoje") return data.toDateString() === agora.toDateString();
    if (periodo === "semana") { const d7 = new Date(agora); d7.setDate(d7.getDate()-7); return data >= d7; }
    if (periodo === "mes")   { const d30 = new Date(agora); d30.setDate(d30.getDate()-30); return data >= d30; }
    return true;
  });

  const concluidas   = filtradas.filter(c => c.status === "completed");
  const canceladas   = filtradas.filter(c => c.status !== "completed");
  const totalGanho   = concluidas.reduce((s, c) => s + (c.valorMotorista || c.valor || 0), 0);
  const totalKm      = concluidas.reduce((s, c) => s + (c.distanciaKm || 0), 0);
  const ticketMedio  = concluidas.length ? totalGanho / concluidas.length : 0;

  // Gráfico de barras por dia (7 dias) ou por semana (30 dias)
  const barsData = React.useMemo(() => {
    const dias = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
    const hoje = new Date().getDay();
    const porDia = Array(7).fill(0);
    const countDia = Array(7).fill(0);
    concluidas.forEach(c => {
      const d = c.concluidoEm?.toDate?.() || c.criadoEm?.toDate?.() || null;
      if (d) {
        const diff = Math.floor((agora - d) / 86400000);
        if (diff < 7) { porDia[6-diff] += (c.valorMotorista||c.valor||0); countDia[6-diff]++; }
      }
    });
    const maxDia = Math.max(...porDia, 1);
    // Mensal: 4 semanas
    const semanas = ["Sem 4","Sem 3","Sem 2","Esta sem"];
    const porSemana = Array(4).fill(0);
    const countSemana = Array(4).fill(0);
    concluidas.forEach(c => {
      const d = c.concluidoEm?.toDate?.() || c.criadoEm?.toDate?.() || null;
      if (d) {
        const diff = Math.floor((agora - d) / 86400000);
        if (diff < 7)        { porSemana[3] += (c.valorMotorista||c.valor||0); countSemana[3]++; }
        else if (diff < 14)  { porSemana[2] += (c.valorMotorista||c.valor||0); countSemana[2]++; }
        else if (diff < 21)  { porSemana[1] += (c.valorMotorista||c.valor||0); countSemana[1]++; }
        else if (diff < 30)  { porSemana[0] += (c.valorMotorista||c.valor||0); countSemana[0]++; }
      }
    });
    const maxSemana = Math.max(...porSemana, 1);
    return { dias, hoje, porDia, countDia, maxVal: maxDia, semanas, porSemana, countSemana, maxSemana };
  }, [concluidas]); // eslint-disable-line react-hooks/exhaustive-deps

  const labelPeriodo = periodo === "hoje" ? "hoje" : periodo === "semana" ? "nos últimos 7 dias" : "nos últimos 30 dias";

  if (carregando) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"60vh", gap:16 }}>
      <div style={{ width:32, height:32, borderRadius:"50%", border:"3px solid rgba(168,85,247,0.2)", borderTopColor:"#a855f7", animation:"spin 0.8s linear infinite" }} />
      <p style={{ color:"rgba(255,255,255,0.3)", fontSize:13, margin:0 }}>Carregando corridas...</p>
    </div>
  );

  return (
    <div style={{ animation:"fadeIn 0.3s ease", paddingBottom:100 }}>

      {/* ── Header gradiente ── */}
      <div style={{ background:"linear-gradient(160deg,#1a0b3b 0%,#0a0e1a 100%)", padding:"52px 20px 24px", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:-60, right:-40, width:200, height:200, borderRadius:"50%", background:"radial-gradient(circle,rgba(168,85,247,0.15) 0%,transparent 70%)", pointerEvents:"none" }}/>
        <h2 style={{ color:"#fff", fontSize:24, fontWeight:800, margin:"0 0 4px", letterSpacing:-0.5 }}>Minhas corridas</h2>
        <p style={{ color:"rgba(255,255,255,0.35)", fontSize:13, margin:"0 0 20px" }}>Histórico e ganhos</p>

        {/* Pills de período */}
        <div style={{ display:"flex", gap:8 }}>
          {[["hoje","Hoje"],["semana","7 dias"],["mes","30 dias"]].map(([val,label]) => (
            <button key={val} onClick={()=>setPeriodo(val)} style={{ flex:1, padding:"9px 0", borderRadius:22, border:"none", background:periodo===val?"linear-gradient(135deg,#7c3aed,#a855f7)":"rgba(255,255,255,0.07)", color:periodo===val?"#fff":"rgba(255,255,255,0.4)", fontSize:13, fontWeight:700, cursor:"pointer", transition:"all 0.2s", boxShadow:periodo===val?"0 4px 14px rgba(168,85,247,0.35)":"none" }}>
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Corridas agendadas próximas ── */}
      {agendadas.length > 0 && (
        <div style={{ margin:"16px 16px 0" }}>
          <p style={{ color:"rgba(255,255,255,0.35)", fontSize:10, fontWeight:700, letterSpacing:1.2, textTransform:"uppercase", margin:"0 0 10px" }}>📅 Corridas agendadas (próximos 7 dias)</p>
          {agendadas.map(ag => {
            const dt = ag.agendadoPara ? new Date(ag.agendadoPara) : null;
            const dataFmt = dt ? dt.toLocaleDateString("pt-BR",{weekday:"short",day:"2-digit",month:"short"}) : "—";
            const horaFmt = dt ? dt.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}) : "—";
            return (
              <div key={ag.id} style={{ background:"rgba(6,182,212,0.06)", border:"1px solid rgba(6,182,212,0.2)", borderRadius:16, padding:"14px 16px", marginBottom:10, display:"flex", alignItems:"flex-start", gap:12 }}>
                <div style={{ flexShrink:0, textAlign:"center", background:"rgba(6,182,212,0.12)", borderRadius:12, padding:"8px 10px", minWidth:48 }}>
                  <p style={{ color:"#06b6d4", fontWeight:800, fontSize:16, margin:0 }}>{dt?.getDate()||"—"}</p>
                  <p style={{ color:"rgba(6,182,212,0.7)", fontSize:9, fontWeight:700, margin:0, textTransform:"uppercase" }}>{dt?.toLocaleString("pt-BR",{month:"short"})||""}</p>
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:4 }}>
                    <p style={{ color:"#06b6d4", fontWeight:800, fontSize:13, margin:0 }}>🕐 {horaFmt} · {dataFmt}</p>
                    <p style={{ color:"#22c55e", fontWeight:800, fontSize:14, margin:0 }}>R$ {Number(ag.valorMotorista||ag.valor||0).toFixed(2)}</p>
                  </div>
                  <p style={{ color:"rgba(255,255,255,0.55)", fontSize:12, margin:"0 0 3px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                    📍 {ag.origem?.endereco||"Origem"}
                  </p>
                  <p style={{ color:"rgba(255,255,255,0.35)", fontSize:12, margin:0, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                    🏁 {ag.destino?.nome||ag.destino?.endereco||"Destino"}
                  </p>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:6 }}>
                    <span style={{ background:"rgba(168,85,247,0.15)", border:"1px solid rgba(168,85,247,0.3)", borderRadius:20, padding:"2px 10px", color:"#a855f7", fontSize:10, fontWeight:700 }}>
                      {ag.categoria==="comfort"?"Zuno Elite":ag.categoria==="moto"?"Zuno Moto":"Zuno Go"}
                    </span>
                    <span style={{ color:"rgba(255,255,255,0.3)", fontSize:11 }}>{ag.passageiroNome}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Card hero de ganhos ── */}
      <div style={{ margin:"16px 16px 0", background:"linear-gradient(135deg,rgba(34,197,94,0.1),rgba(6,182,212,0.06))", border:"1px solid rgba(34,197,94,0.2)", borderRadius:20, padding:"20px" }}>
        <p style={{ color:"rgba(255,255,255,0.4)", fontSize:11, fontWeight:700, letterSpacing:1.5, textTransform:"uppercase", margin:"0 0 6px" }}>
          Total ganho {labelPeriodo}
        </p>
        <p style={{ color:"#22c55e", fontSize:36, fontWeight:900, margin:"0 0 16px", letterSpacing:-1 }}>
          R$ {totalGanho.toLocaleString("pt-BR", { minimumFractionDigits:2, maximumFractionDigits:2 })}
        </p>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:0 }}>
          {[
            { label:"Corridas", value: concluidas.length, color:"#fff" },
            { label:"Km rodados", value: totalKm.toFixed(1), color:"#06b6d4" },
            { label:"Ticket médio", value: `R$ ${ticketMedio.toFixed(2)}`, color:"#a855f7" },
          ].map((item, i) => (
            <div key={i} style={{ textAlign:"center", borderLeft: i>0 ? "1px solid rgba(255,255,255,0.07)" : "none", padding:"0 8px" }}>
              <p style={{ color: item.color, fontSize:18, fontWeight:800, margin:"0 0 2px" }}>{item.value}</p>
              <p style={{ color:"rgba(255,255,255,0.35)", fontSize:10, fontWeight:600, letterSpacing:0.8, textTransform:"uppercase", margin:0 }}>{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── Gráfico de barras ── */}
      {concluidas.length > 0 && (periodo === "semana" || periodo === "mes") && (
        <div style={{ margin:"12px 16px 0", background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:18, padding:"16px" }}>
          <p style={{ color:"rgba(255,255,255,0.3)", fontSize:10, fontWeight:700, letterSpacing:1.2, textTransform:"uppercase", margin:"0 0 14px" }}>
            {periodo === "semana" ? "Ganhos por dia" : "Ganhos por semana"}
          </p>
          <div style={{ display:"flex", alignItems:"flex-end", gap:periodo==="mes"?10:5, height:80 }}>
            {periodo === "semana"
              ? barsData.porDia.map((val, i) => {
                  const diaSemana = (barsData.hoje - (6 - i) + 7) % 7;
                  const isHoje = i === 6;
                  const pct = Math.max((val / barsData.maxVal), val > 0 ? 0.08 : 0.02);
                  return (
                    <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:5, height:"100%" }}>
                      <div style={{ flex:1, width:"100%", display:"flex", alignItems:"flex-end" }}>
                        <div style={{ width:"100%", height:`${pct*100}%`, minHeight: val>0?6:2, borderRadius:"4px 4px 2px 2px", background:isHoje?"linear-gradient(180deg,#4ade80,#22c55e)":val>0?"linear-gradient(180deg,#c084fc,#7c3aed)":"rgba(255,255,255,0.05)", transition:"height 0.5s cubic-bezier(0.34,1.56,0.64,1)" }}/>
                      </div>
                      <div style={{ textAlign:"center" }}>
                        <p style={{ fontSize:9, color:isHoje?"#22c55e":"rgba(255,255,255,0.3)", fontWeight:isHoje?800:400, margin:0 }}>{barsData.dias[diaSemana]}</p>
                        {barsData.countDia[i] > 0 && <p style={{ fontSize:8, color:"rgba(255,255,255,0.2)", margin:0 }}>{barsData.countDia[i]}x</p>}
                      </div>
                    </div>
                  );
                })
              : barsData.porSemana.map((val, i) => {
                  const isEsta = i === 3;
                  const pct = Math.max((val / barsData.maxSemana), val > 0 ? 0.08 : 0.02);
                  return (
                    <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:5, height:"100%" }}>
                      <div style={{ flex:1, width:"100%", display:"flex", alignItems:"flex-end" }}>
                        <div style={{ width:"100%", height:`${pct*100}%`, minHeight:val>0?8:2, borderRadius:"6px 6px 2px 2px", background:isEsta?"linear-gradient(180deg,#4ade80,#22c55e)":val>0?"linear-gradient(180deg,#c084fc,#7c3aed)":"rgba(255,255,255,0.05)", transition:"height 0.5s cubic-bezier(0.34,1.56,0.64,1)" }}/>
                      </div>
                      <div style={{ textAlign:"center" }}>
                        <p style={{ fontSize:9, color:isEsta?"#22c55e":"rgba(255,255,255,0.3)", fontWeight:isEsta?800:400, margin:0 }}>{barsData.semanas[i]}</p>
                        {barsData.countSemana[i] > 0 && <p style={{ fontSize:8, color:"rgba(255,255,255,0.2)", margin:0 }}>R${barsData.porSemana[i].toFixed(0)}</p>}
                      </div>
                    </div>
                  );
                })
            }
          </div>
        </div>
      )}

      {/* ── Canceladas / taxa ── */}
      {canceladas.length > 0 && (
        <div style={{ margin:"12px 16px 0", background:"rgba(239,68,68,0.05)", border:"1px solid rgba(239,68,68,0.12)", borderRadius:14, padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:8, height:8, borderRadius:"50%", background:"#f87171" }}/>
            <p style={{ color:"rgba(255,255,255,0.5)", fontSize:13, margin:0 }}>{canceladas.length} cancelada{canceladas.length>1?"s":""} {labelPeriodo}</p>
          </div>
          <p style={{ color:"#f87171", fontSize:13, fontWeight:700, margin:0 }}>
            {Math.round((canceladas.length/(filtradas.length||1))*100)}% cancelamento
          </p>
        </div>
      )}

      {/* ── Lista de corridas ── */}
      <div style={{ padding:"12px 16px 0" }}>
        {filtradas.length === 0 ? (
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"35vh", gap:16 }}>
            <div style={{ width:72, height:72, borderRadius:"50%", background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" strokeLinecap="round"><circle cx="5" cy="6" r="2.5"/><path d="M19 15.5c0 2-2 4-2 4s-2-2-2-4a2 2 0 014 0z"/><path d="M5 8.5C5 12 10 12 12 15.5M12 15.5C14 19 19 15.5 19 15.5"/></svg>
            </div>
            <div style={{ textAlign:"center" }}>
              <p style={{ color:"rgba(255,255,255,0.5)", fontSize:15, fontWeight:700, margin:"0 0 4px" }}>Nenhuma corrida</p>
              <p style={{ color:"rgba(255,255,255,0.25)", fontSize:13, margin:0 }}>Você não teve corridas {labelPeriodo}</p>
            </div>
          </div>
        ) : (
          <>
            <p style={{ color:"rgba(255,255,255,0.25)", fontSize:11, fontWeight:700, letterSpacing:1, textTransform:"uppercase", margin:"4px 0 12px" }}>{filtradas.length} corrida{filtradas.length>1?"s":""}</p>
            {filtradas.map((c) => {
              const concluida = c.status === "completed";
              const pag = iconePagamento(c.metodoPagamento || "dinheiro");
              const data = c.concluidoEm?.toDate?.() || c.criadoEm?.toDate?.() || null;
              const hora = data ? data.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}) : "—";
              const dia  = data ? data.toLocaleDateString("pt-BR",{day:"2-digit",month:"short"}) : "—";
              const valor = Number(c.valorMotorista||c.valor||0);
              return (
                <div key={c.id} style={{ background:"rgba(255,255,255,0.03)", border:`1px solid ${concluida?"rgba(34,197,94,0.12)":"rgba(239,68,68,0.1)"}`, borderRadius:18, padding:"16px", marginBottom:10, position:"relative", overflow:"hidden" }}>
                  {/* Borda colorida lateral */}
                  <div style={{ position:"absolute", left:0, top:0, bottom:0, width:3, borderRadius:"18px 0 0 18px", background:concluida?"linear-gradient(180deg,#22c55e,#16a34a)":"linear-gradient(180deg,#f87171,#ef4444)" }}/>

                  {/* Linha superior */}
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12, paddingLeft:8 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <div style={{ padding:"3px 10px", borderRadius:20, background:concluida?"rgba(34,197,94,0.12)":"rgba(239,68,68,0.1)", border:`1px solid ${concluida?"rgba(34,197,94,0.25)":"rgba(239,68,68,0.2)"}` }}>
                        <span style={{ fontSize:11, color:concluida?"#4ade80":"#f87171", fontWeight:700 }}>{concluida?"✓ Concluída":"✕ Cancelada"}</span>
                      </div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <p style={{ color:"rgba(255,255,255,0.5)", fontSize:11, margin:0 }}>{dia}</p>
                      <p style={{ color:"rgba(255,255,255,0.3)", fontSize:10, margin:0 }}>{hora}</p>
                    </div>
                  </div>

                  {/* Rota */}
                  <div style={{ display:"flex", gap:10, alignItems:"flex-start", marginBottom:12, paddingLeft:8 }}>
                    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:3, paddingTop:3, flexShrink:0 }}>
                      <div style={{ width:8, height:8, borderRadius:"50%", background:"#22c55e" }}/>
                      <div style={{ width:1.5, height:20, background:"rgba(255,255,255,0.1)" }}/>
                      <div style={{ width:8, height:8, borderRadius:2, background:concluida?"#a855f7":"#f87171" }}/>
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <p style={{ color:"rgba(255,255,255,0.45)", fontSize:11, margin:"0 0 14px", lineHeight:1.3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                        {c.origem?.endereco || "Origem"}
                      </p>
                      <p style={{ color:"rgba(255,255,255,0.7)", fontSize:12, fontWeight:600, margin:0, lineHeight:1.3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                        {c.destino?.nome || c.destino?.endereco || "Destino"}
                      </p>
                    </div>
                  </div>

                  {/* Footer */}
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", paddingLeft:8, paddingTop:10, borderTop:"1px solid rgba(255,255,255,0.05)" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:5, padding:"4px 10px", borderRadius:20, background:`rgba(${pag.cor==="#22c55e"?"34,197,94":pag.cor==="#06b6d4"?"6,182,212":"59,130,246"},0.1)`, border:`1px solid rgba(${pag.cor==="#22c55e"?"34,197,94":pag.cor==="#06b6d4"?"6,182,212":"59,130,246"},0.2)` }}>
                        <span style={{ fontSize:12 }}>{pag.icon}</span>
                        <span style={{ fontSize:11, color:pag.cor, fontWeight:600 }}>{pag.label}</span>
                      </div>
                      {c.distanciaKm > 0 && (
                        <span style={{ fontSize:11, color:"rgba(255,255,255,0.3)" }}>{Number(c.distanciaKm).toFixed(1)} km</span>
                      )}
                    </div>
                    <p style={{ fontSize:20, fontWeight:900, color:concluida?"#4ade80":"rgba(255,255,255,0.2)", margin:0, letterSpacing:-0.5 }}>
                      {concluida ? `R$ ${valor.toFixed(2)}` : "—"}
                    </p>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

// ─── ABA PERFIL ──────────────────────────────────────────────
function TabPerfil({ motorista, user, fotoURL, uploadingFoto, handleFotoChange, fileInputRef, savedMsg, nomeMotorista, avaliacao, placa, cidade, estado, navigate, qrCodeUrl, uploadingQr, qrInputRef }) {
  const [totalCorridas, setTotalCorridas] = React.useState(null);

  React.useEffect(() => {
    if (!user?.uid) return;
    import("firebase/firestore").then(({ collection, query, where, getDocs }) => {
      const q = query(collection(db, "driver_cobrancas"), where("driverUid", "==", user.uid));
      getDocs(q).then(snap => {
        const total = snap.docs.reduce((s, d) => s + (d.data().totalCorridas || 0), 0);
        setTotalCorridas(total);
      }).catch(() => {});
    });
  }, [user?.uid]);

  const tempoNaPlataforma = React.useMemo(() => {
    const dt = motorista?.aprovadoEm?.toDate?.() || motorista?.criadoEm?.toDate?.();
    if (!dt) return null;
    const meses = Math.floor((Date.now() - dt.getTime()) / (1000 * 60 * 60 * 24 * 30));
    if (meses < 1) return "< 1 mês";
    if (meses < 12) return `${meses} mês${meses > 1 ? "es" : ""}`;
    const anos = Math.floor(meses / 12); const m = meses % 12;
    return `${anos} ano${anos > 1 ? "s" : ""}${m > 0 ? ` e ${m} mês${m > 1 ? "es" : ""}` : ""}`;
  }, [motorista]);

  const badges = React.useMemo(() => {
    const b = [];
    if (motorista?.status === "approved") b.push({ icon:"✅", label:"Motorista verificado" });
    if (totalCorridas >= 1500) b.push({ icon:"👑", label:"1500 viagens 5 estrelas" });
    else if (totalCorridas >= 1000) b.push({ icon:"🏆", label:"1000 viagens" });
    else if (totalCorridas >= 500) b.push({ icon:"🥇", label:"500 viagens" });
    else if (totalCorridas >= 100) b.push({ icon:"🎯", label:"100 viagens" });
    const aprovadoEm = motorista?.aprovadoEm?.toDate?.();
    if (aprovadoEm) {
      const anos = Math.floor((Date.now() - aprovadoEm.getTime()) / (1000 * 60 * 60 * 24 * 365));
      if (anos >= 1) b.push({ icon:"🎂", label:`${anos} ano${anos > 1 ? "s" : ""} com a Zuno` });
    }
    if (avaliacao >= 4.9) b.push({ icon:"⭐", label:"Nota excepcional" });
    return b;
  }, [motorista, totalCorridas, avaliacao]);

  return (
    <div style={{ animation:"fadeIn 0.3s ease", paddingBottom:80 }}>
      {/* ── Header / Hero ── */}
      <div style={{ background:"linear-gradient(160deg,#1a0b3b 0%,#0a0e1a 100%)", padding:"52px 24px 28px", textAlign:"center", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:-40, right:-40, width:160, height:160, borderRadius:"50%", background:"radial-gradient(circle,rgba(124,58,237,0.2) 0%,transparent 70%)", pointerEvents:"none" }}/>
        <div style={{ position:"relative", display:"inline-block", marginBottom:12 }}>
          <Avatar fotoURL={fotoURL} nome={nomeMotorista} size={96} fontSize={36} />
          <button onClick={()=>fileInputRef.current?.click()} disabled={uploadingFoto}
            style={{ position:"absolute", bottom:2, right:2, width:30, height:30, borderRadius:"50%", background:"linear-gradient(135deg,#7c3aed,#a855f7)", border:"2px solid #0a0e1a", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer" }}>
            {uploadingFoto ? <div style={{ width:12, height:12, borderRadius:"50%", border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"#fff", animation:"spin 0.7s linear infinite" }}/> : <IconCamera/>}
          </button>
          <input ref={fileInputRef} type="file" accept="image/*" style={{ display:"none" }} onChange={handleFotoChange}/>
        </div>
        <p style={{ color:"#fff", fontWeight:700, fontSize:19, margin:"0 0 2px" }}>{nomeMotorista}</p>
        <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(34,197,94,0.12)", border:"1px solid rgba(34,197,94,0.3)", borderRadius:20, padding:"3px 10px", marginBottom:12 }}>
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          <span style={{ color:"#22c55e", fontSize:11, fontWeight:700 }}>Motorista Verificado</span>
        </div>
        <div style={{ display:"flex", justifyContent:"center", gap:2, marginBottom:4 }}>
          {[1,2,3,4,5].map(i=><IconStar key={i} filled={i<=Math.round(avaliacao)}/>)}
          <span style={{ color:"#f59e0b", fontSize:14, fontWeight:700, marginLeft:4 }}>{Number(avaliacao).toFixed(2)}</span>
        </div>
        <p style={{ color:"rgba(255,255,255,0.35)", fontSize:12, margin:0 }}>Avaliação média em estrelas</p>
        {savedMsg && <div style={{ marginTop:10, background:"rgba(34,197,94,0.15)", border:"1px solid rgba(34,197,94,0.3)", borderRadius:10, padding:"6px 14px", display:"inline-block" }}><span style={{ color:"#22c55e", fontSize:13 }}>{savedMsg}</span></div>}
      </div>

      {/* ── Viagens / Stats ── */}
      <SectionTitle title="Desempenho" />
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, margin:"0 16px" }}>
        <div style={{ ...s.infoCard, margin:0, padding:"14px 16px" }}>
          <p style={{ color:"#fff", fontWeight:800, fontSize:28, margin:"0 0 2px" }}>{totalCorridas !== null ? totalCorridas.toLocaleString("pt-BR") : "—"}</p>
          <p style={{ color:"rgba(255,255,255,0.45)", fontSize:12, margin:0 }}>Total de viagens</p>
        </div>
        <div style={{ ...s.infoCard, margin:0, padding:"14px 16px" }}>
          <p style={{ color:"#fff", fontWeight:800, fontSize:28, margin:"0 0 2px" }}>{tempoNaPlataforma || "—"}</p>
          <p style={{ color:"rgba(255,255,255,0.45)", fontSize:12, margin:0 }}>Tempo na Zuno</p>
        </div>
        {/* Taxa de aceitação */}
        {(() => {
          const recebidas = motorista?.totalRecebidas || 0;
          const aceitas   = motorista?.totalAceitas   || 0;
          const taxa = recebidas > 0 ? Math.round((aceitas / recebidas) * 100) : null;
          const cor  = taxa === null ? "#fff" : taxa >= 80 ? "#22c55e" : taxa >= 60 ? "#f59e0b" : "#ef4444";
          return (
            <div style={{ ...s.infoCard, margin:0, padding:"14px 16px" }}>
              <p style={{ color:cor, fontWeight:800, fontSize:28, margin:"0 0 2px" }}>{taxa !== null ? `${taxa}%` : "—"}</p>
              <p style={{ color:"rgba(255,255,255,0.45)", fontSize:12, margin:0 }}>Taxa de aceitação</p>
              {recebidas > 0 && <p style={{ color:"rgba(255,255,255,0.25)", fontSize:10, margin:"4px 0 0" }}>{aceitas}/{recebidas} corridas</p>}
            </div>
          );
        })()}
        {/* Taxa de cancelamento */}
        {(() => {
          const recebidas   = motorista?.totalRecebidas   || 0;
          const cancelamentos = motorista?.totalCancelamentos || 0;
          const taxa = recebidas > 0 ? Math.round((cancelamentos / recebidas) * 100) : null;
          const cor  = taxa === null ? "#fff" : taxa <= 5 ? "#22c55e" : taxa <= 15 ? "#f59e0b" : "#ef4444";
          return (
            <div style={{ ...s.infoCard, margin:0, padding:"14px 16px" }}>
              <p style={{ color:cor, fontWeight:800, fontSize:28, margin:"0 0 2px" }}>{taxa !== null ? `${taxa}%` : "—"}</p>
              <p style={{ color:"rgba(255,255,255,0.45)", fontSize:12, margin:0 }}>Cancelamentos</p>
              {cancelamentos > 0 && <p style={{ color:"rgba(255,255,255,0.25)", fontSize:10, margin:"4px 0 0" }}>{cancelamentos} canceladas</p>}
            </div>
          );
        })()}
      </div>

      {/* ── Conquistas / Badges ── */}
      {badges.length > 0 && (
        <>
          <SectionTitle title="Conquistas" />
          <div style={{ display:"flex", gap:12, margin:"0 16px", flexWrap:"wrap" }}>
            {badges.map((b, i) => (
              <div key={i} style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:6, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:"14px 16px", minWidth:80, flex:"1 1 auto", maxWidth:120 }}>
                <span style={{ fontSize:28 }}>{b.icon}</span>
                <span style={{ color:"rgba(255,255,255,0.6)", fontSize:10, fontWeight:600, textAlign:"center", lineHeight:1.3 }}>{b.label}</span>
              </div>
            ))}
          </div>
        </>
      )}

      {/* ── Dados Pessoais ── */}
      <SectionTitle title="Dados Pessoais" />
      <div style={{ ...s.infoCard, margin:"0 16px" }}>
        <InfoRow label="Nome" value={nomeMotorista}/><div style={s.divider}/><InfoRow label="E-mail" value={user?.email||"—"}/>
      </div>

      {/* ── Veículo ── */}
      <SectionTitle title="Veículo" />
      <div style={{ ...s.infoCard, margin:"0 16px" }}>
        <InfoRow label="Placa" value={placa} mono/><div style={s.divider}/>
        <InfoRow label="Modelo" value={motorista?(motorista.marca+" "+motorista.modelo):"—"}/><div style={s.divider}/>
        <InfoRow label="Cidade" value={cidade+(estado?" — "+estado:"")}/>
      </div>

      {/* ── Pix ── */}
      <SectionTitle title="Pagamento Pix" />
      <div style={{ ...s.infoCard, margin:"0 16px" }}>
        <div style={{ padding:"16px 0" }}>
          <p style={{ color:"rgba(255,255,255,0.35)", fontSize:11, margin:"0 0 4px" }}>Chave Pix cadastrada</p>
          <p style={{ color:"#06b6d4", fontSize:14, fontWeight:700, margin:"0 0 16px", wordBreak:"break-all" }}>{motorista?.chavePix||"Não cadastrada"}</p>
          {qrCodeUrl && (
            <div style={{ marginBottom:16, textAlign:"center" }}>
              <div style={{ background:"#fff", borderRadius:12, padding:12, display:"inline-block" }}>
                <img src={qrCodeUrl} alt="QR Code" style={{ width:140, height:140, display:"block" }}/>
              </div>
              <p style={{ color:"rgba(255,255,255,0.25)", fontSize:11, marginTop:8 }}>Este QR Code aparece para o passageiro durante a corrida</p>
            </div>
          )}
          <button onClick={()=>qrInputRef.current?.click()} disabled={uploadingQr} style={{ width:"100%", padding:"12px", borderRadius:12, border:"1px solid rgba(6,182,212,0.3)", background:"rgba(6,182,212,0.08)", color:"#06b6d4", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
            {uploadingQr?"Enviando...":qrCodeUrl?"📱 Trocar QR Code Pix":"📱 Adicionar QR Code Pix"}
          </button>
        </div>
      </div>

      {/* ── Ações ── */}
      <SectionTitle title="Ações" />
      <div style={{ ...s.infoCard, margin:"0 16px" }}>
        <ActionRow label="Trocar foto" icon="📷" onClick={()=>fileInputRef.current?.click()}/><div style={s.divider}/>
        <ActionRow label="Documentação e verificação" icon="📄" onClick={()=>navigate("/cadastro-motorista")}/><div style={s.divider}/>
        <ActionRow label="Extrato financeiro" icon="💰" onClick={()=>navigate("/extrato-motorista")}/>
      </div>
    </div>
  );
}

// ─── ABA CONFIG ──────────────────────────────────────────────
function TabConfig({ notificacoes, setNotificacoes, sons, setSons, logout, navigate, planoInfo, handleMigrarFlex }) {
  const excluirConta = async () => {
    if (!window.confirm("Solicitar a exclusão da sua conta de motorista Zuno? Você ficará offline e será desconectado.")) return;
    try {
      await requestAccountDeletion();
      await logout();
    } catch (error) {
      window.alert(error?.message || "Não foi possível solicitar a exclusão agora.");
    }
  };
  return (
    <div style={{ animation:"fadeIn 0.3s ease", paddingBottom:80 }}>
      <div style={s.pageHeader}><h2 style={s.pageTitle}>Configurações</h2></div>
      {planoInfo && (
        <>
          <SectionTitle title="Meu Plano" />
          <div style={{ ...s.infoCard, margin:"0 16px" }}>
            <div style={{ padding:"14px 0" }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ fontSize:20 }}>{planoInfo.plano==="flex"?"⚡":"💼"}</span>
                  <span style={{ fontSize:14, fontWeight:700, color:"#fff" }}>{planoInfo.plano==="flex"?"Plano Flex":"Plano Mensalidade"}</span>
                </div>
                <div style={{ padding:"3px 10px", borderRadius:50, background:planoInfo.plano==="flex"?"rgba(245,158,11,0.15)":"rgba(124,58,237,0.15)", border:`1px solid ${planoInfo.plano==="flex"?"rgba(245,158,11,0.3)":"rgba(168,85,247,0.3)"}` }}>
                  <span style={{ fontSize:11, fontWeight:700, color:planoInfo.plano==="flex"?"#f59e0b":"#a855f7" }}>{planoInfo.trialAtivo?`Trial • ${planoInfo.diasRestantes}d`:"Ativo"}</span>
                </div>
              </div>
              <p style={{ fontSize:12, color:"rgba(255,255,255,0.4)", margin:"0 0 10px" }}>{planoInfo.plano==="flex"?"8% por corrida • Sem mensalidade":"100% por corrida • Mensalidade fixa"}</p>
              {planoInfo.plano==="mensalidade" && <button onClick={handleMigrarFlex} style={{ width:"100%", padding:"10px", borderRadius:10, background:"rgba(245,158,11,0.1)", border:"1px solid rgba(245,158,11,0.3)", color:"#f59e0b", fontSize:13, fontWeight:700, cursor:"pointer" }}>⚡ Migrar para Plano Flex</button>}
              {planoInfo.plano==="flex" && <button onClick={()=>navigate("/plano-motorista")} style={{ width:"100%", padding:"10px", borderRadius:10, background:"rgba(124,58,237,0.1)", border:"1px solid rgba(168,85,247,0.3)", color:"#a855f7", fontSize:13, fontWeight:700, cursor:"pointer" }}>💼 Ver Plano Mensalidade</button>}
            </div>
          </div>
        </>
      )}
      <SectionTitle title="Preferências" />
      <div style={{ ...s.infoCard, margin:"0 16px" }}>
        <ToggleRow label="Notificações" icon="🔔" value={notificacoes} onChange={setNotificacoes}/><div style={s.divider}/>
        <ToggleRow label="Sons de alerta" icon="🔊" value={sons} onChange={setSons}/>
      </div>
      <SectionTitle title="Suporte" />
      <div style={{ ...s.infoCard, margin:"0 16px" }}>
        <ActionRow label="Falar com suporte" icon="☎️" onClick={()=>window.open("tel:+5511917934340","_self")}/><div style={s.divider}/>
        <ActionRow label="Termos de uso" icon="📜" onClick={()=>navigate("/termos")}/>
      </div>
      <div style={{ margin:"24px 16px 0" }}>
        <button onClick={logout} style={{ width:"100%", padding:"14px", borderRadius:14, background:"rgba(239,68,68,0.1)", border:"1px solid rgba(239,68,68,0.3)", color:"#ef4444", fontSize:14, fontWeight:700, cursor:"pointer" }}>🚪 Sair da conta</button>
        <button onClick={excluirConta} style={{ width:"100%", marginTop:10, padding:"12px", borderRadius:14, background:"transparent", border:"1px solid rgba(239,68,68,0.25)", color:"#ef4444", fontSize:12, cursor:"pointer" }}>Solicitar exclusão da conta e dos dados</button>
      </div>
      <p style={{ textAlign:"center", color:"rgba(255,255,255,0.15)", fontSize:11, marginTop:20 }}>Zuno App v1.0.0</p>
    </div>
  );
}

// ─── AUXILIARES ──────────────────────────────────────────────
function Avatar({ fotoURL, nome, size=48, fontSize=20 }) {
  if (fotoURL) return <div style={{ width:size, height:size, borderRadius:"50%", overflow:"hidden", border:"2px solid rgba(168,85,247,0.4)", flexShrink:0 }}><img src={fotoURL} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }}/></div>;
  return <div style={{ width:size, height:size, borderRadius:"50%", background:"linear-gradient(135deg,#7c3aed,#2563eb)", display:"flex", alignItems:"center", justifyContent:"center", fontSize, fontWeight:700, color:"#fff", border:"2px solid rgba(255,255,255,0.1)", flexShrink:0 }}>{nome?nome.charAt(0).toUpperCase():"M"}</div>;
}
function StatCard({ icon, label, value, sub, accent }) {
  return <div style={{ ...s.statCard, borderTop:"2px solid "+(accent||"rgba(255,255,255,0.08)") }}><span style={{ fontSize:15 }}>{icon}</span><span style={{ fontSize:10, color:"rgba(255,255,255,0.4)", marginTop:3 }}>{label}</span><span style={{ fontSize:14, fontWeight:700, color:"#fff" }}>{value}</span><span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{sub}</span></div>;
}
function InfoRow({ label, value, mono }) {
  return <div style={s.infoRow}><span style={{ fontSize:13, color:"rgba(255,255,255,0.45)" }}>{label}</span>{typeof value==="string"?<span style={{ fontSize:13, color:"#fff", fontWeight:600, letterSpacing:mono?2:0 }}>{value}</span>:value}</div>;
}
function ActionRow({ label, icon, onClick }) {
  return <div className="setting-row" onClick={onClick} style={{ ...s.infoRow, cursor:"pointer", borderRadius:10, padding:"14px 4px" }}><div style={{ display:"flex", alignItems:"center", gap:10 }}><span style={{ fontSize:18 }}>{icon}</span><span style={{ fontSize:14, color:"rgba(255,255,255,0.8)" }}>{label}</span></div><IconChevron/></div>;
}
function ToggleRow({ label, icon, value, onChange }) {
  return <div style={{ ...s.infoRow, padding:"14px 4px" }}><div style={{ display:"flex", alignItems:"center", gap:10 }}><span style={{ fontSize:18 }}>{icon}</span><span style={{ fontSize:14, color:"rgba(255,255,255,0.8)" }}>{label}</span></div><button onClick={()=>onChange(!value)} style={{ width:46, height:26, borderRadius:13, border:"none", cursor:"pointer", background:value?"linear-gradient(135deg,#7c3aed,#a855f7)":"rgba(255,255,255,0.1)", position:"relative", transition:"background 0.3s", flexShrink:0 }}><div style={{ position:"absolute", top:3, left:value?23:3, width:20, height:20, borderRadius:"50%", background:"#fff", transition:"left 0.3s" }}/></button></div>;
}
function SectionTitle({ title }) {
  return <div style={{ padding:"20px 20px 8px" }}><span style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.3)", letterSpacing:1.5, textTransform:"uppercase" }}>{title}</span></div>;
}

const s = {
  root: { height:"100vh", overflow:"hidden", background:"#0a0e1a", display:"flex", flexDirection:"column", maxWidth:480, margin:"0 auto", position:"relative", fontFamily:"'Segoe UI', system-ui, sans-serif" },
  content: { flex:1, overflowY:"auto", overflowX:"hidden", position:"relative" },
  bottomNav: { position:"fixed", bottom:0, left:"50%", transform:"translateX(-50%)", width:"100%", maxWidth:480, background:"rgba(10,14,26,0.95)", backdropFilter:"blur(20px)", borderTop:"1px solid rgba(255,255,255,0.07)", display:"flex", zIndex:1000, paddingBottom:"env(safe-area-inset-bottom, 0px)" },
  statCard: { background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:12, padding:"8px 8px", display:"flex", flexDirection:"column", alignItems:"center", gap:1 },
  infoCard: { background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, padding:"4px 16px", margin:"0 16px" },
  infoRow: { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"14px 0" },
  divider: { height:1, background:"rgba(255,255,255,0.05)" },
  pageHeader: { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"52px 20px 16px" },
  pageTitle: { color:"#fff", fontSize:22, fontWeight:700, margin:0 },
};

export default DriverHome;
